<template>
  <v-card class="rsl-fixed-height">
    <v-tabs v-model="tab">
      <v-tab>
        {{ $t('ADMIN.TABS.USERS') }}
      </v-tab>
      <v-tab>
        {{ $t('ADMIN.TABS.GROUPS') }}
      </v-tab>
      <v-tab v-if="theCurrentRole == 'adminRole'">
        {{ $t('ADMIN.TABS.SETTINGS') }}
      </v-tab>
      <v-tab>
        {{ $t('ADMIN.TABS.CONNECTIONS') }}
      </v-tab>
      <v-tab>
        {{ $t('ADMIN.TABS.API_VAULT') }}
      </v-tab>
      <v-tab v-if="theCurrentRole == 'adminRole'">
        {{ $t('ADMIN.TABS.LDAP_SSO') }}
      </v-tab>
      <v-tab v-if="theCurrentRole == 'adminRole'">
        {{ $t('ADMIN.TABS.OPS_LOG') }}
      </v-tab>
      <v-tab>
        {{ $t('ADMIN.TABS.ERROR_LOG') }}
      </v-tab>
      <v-tab v-if="theCurrentRole == 'adminRole'">
        {{ $t('ADMIN.TABS.LICENSE') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.USERS.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchUsers"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.USERS.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="addUser()"
                  >{{ $t('ADMIN.USERS.BTNS.ADD_USER') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="userHeaders"
                  :items="allUsers"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchUsers"
                  class="elevation-1 user-list"
                  item-key="id"
                  :sort-by="usersSortBy"
                  :sort-desc="usersSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingUsers"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      v-if="row.item.id != 'hqadmin'"
                      small
                      class="mr-2"
                      color="success"
                      @click="editUser(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      v-if="row.item.id != 'hqadmin' && row.item.id != theCurrentUser"
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteUser(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="editUserDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ editUserTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ editUserText }}</div>
                        <div class="pt-5 red--text pb-4">{{ passwordPolicy }}</div>

                        <v-form v-model="isFormValid" ref="editUserForm">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="userId"
                                :label="$t('ADMIN.USERS.FIELDS.USERNAME')"
                                :rules="[rules.required]"
                                :disabled="true"
                              >{{ userId }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="email"
                                :label="$t('ADMIN.USERS.FIELDS.EMAIL')"
                                :rules="[rules.required, rules.email]"
                              >{{ email }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="firstName"
                                :label="$t('ADMIN.USERS.FIELDS.FIRSTNAME')"
                                :rules="[rules.required]"
                              >{{ firstName }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="lastName"
                                :label="$t('ADMIN.USERS.FIELDS.LASTNAME')"
                                :rules="[rules.required]"
                              >{{ lastName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-select
                                v-model="role"
                                :items="allRoles"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.USERS.FIELDS.ROLE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="password1"
                                :label="$t('ADMIN.USERS.FIELDS.PASS')"
                                :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                :rules="[rules.password]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                onpaste="return false"
                                v-model="password2"
                                :label="$t('ADMIN.USERS.FIELDS.CONFIRM_PASS')"
                                :append-icon="showPass2 ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass2 ? 'text' : 'password'"
                                @click:append="showPass2 = !showPass2"
                                :rules="password1 != '' ? [rules.required, rules.password, rules.passMatch] : []"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <div v-if="remoteUserTenants.length > 0">
                            <v-row>
                              <v-col cols="12">
                                <div class="pt-5 pb-5">{{ $t('ADMIN.USERS.EDIT_USER.MULTI_INSTANCE_TOGGLE') }}</div>
                                <v-switch
                                  v-model="updateAllInstances"
                                  color="success"
                                  :label="$t('ADMIN.USERS.EDIT_USER.MULTI_INSTANCE_LABEL')"
                                ></v-switch>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="allHqConns.length > 0">
                            <div class="pt-5 pb-5">{{ $t('ADMIN.USERS.EDIT_USER.MULTI_INSTANCE') }}</div>
                            <v-row v-for="item in allHqConns" :key="item.ID">
                              <v-col cols="12" sm="4">
                                <div class="engine-name text-subtitle-1">{{item.ENGINE_NAME}}</div>
                              </v-col>
                              <div v-for="tenant in tenantInfo" :key="tenant.id">
                                <v-col cols="12" sm="4" v-if="tenant.engineId == item.ID">
                                  <v-checkbox
                                    v-model="tenantSelected"
                                    :label="tenant.tenantName"
                                    :value="tenant.id"
                                    hide-details
                                    class="tenant-info"
                                  ></v-checkbox>
                                </v-col>
                              </div>                              
                            </v-row>
                          </div>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelEditUser()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmEditUser({userId, email, firstName, lastName, role, password1, password2})"
                        >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="400"
                    v-model="deleteUserDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ deleteUserTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ deleteUserText }}</div>
                        <div v-if="allHqConns.length > 0 && remoteUserTenants.length > 0">
                          <div class="pt-5 pb-5">{{ $t('ADMIN.USERS.DELETE_USER.MULTI_INSTANCE') }}</div>
                          <v-row v-for="item in allHqConns" :key="item.ID">
                            <v-col cols="12" sm="4">
                              <div class="engine-name text-subtitle-1">{{item.ENGINE_NAME}}</div>
                            </v-col>
                            <div v-for="tenant in remoteUserTenants" :key="tenant.id">
                              <v-col cols="12" sm="4" v-if="tenant.engineId == item.ID">
                                <v-checkbox
                                  v-model="tenantSelected"
                                  :label="tenant.tenantName"
                                  :value="tenant.id"
                                  hide-details
                                  class="tenant-info"
                                ></v-checkbox>
                              </v-col>
                            </div>                              
                          </v-row>
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="deleteUserDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmDeleteUser({userId})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="addUserDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addUserTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ addUserText }}</div>
                        <div class="pt-5 red--text pb-4">{{ passwordPolicy }}</div>

                        <v-form v-model="isFormValid" ref="addUserForm">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="userId"
                                :label="$t('ADMIN.USERS.FIELDS.USERNAME')"
                                autocomplete="username"
                                :rules="[rules.required]"
                              >{{ userId }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="email"
                                :label="$t('ADMIN.USERS.FIELDS.EMAIL')"
                                :rules="[rules.required, rules.email]"
                              >{{ email }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="firstName"
                                :label="$t('ADMIN.USERS.FIELDS.FIRSTNAME')"
                                :rules="[rules.required]"
                              >{{ firstName }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="lastName"
                                :label="$t('ADMIN.USERS.FIELDS.LASTNAME')"
                                :rules="[rules.required]"
                              >{{ lastName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-select
                                v-model="role"
                                :items="allRoles"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.USERS.FIELDS.ROLE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="password1"
                                :label="$t('ADMIN.USERS.FIELDS.PASS')"
                                :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                :rules="[rules.required, rules.password]"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                onpaste="return false"
                                v-model="password2"
                                :label="$t('ADMIN.USERS.FIELDS.CONFIRM_PASS')"
                                :append-icon="showPass2 ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass2 ? 'text' : 'password'"
                                @click:append="showPass2 = !showPass2"
                                :rules="[rules.required, rules.password, rules.passMatch]"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <div v-if="allHqConns.length > 0">
                            <div class="pt-5 pb-5">{{ $t('ADMIN.USERS.ADD_USER.MULTI_INSTANCE') }}</div>
                            <v-row v-for="item in allHqConns" :key="item.ID">
                              <v-col cols="12" sm="4">
                                <div class="engine-name text-subtitle-1">{{item.ENGINE_NAME}}</div>
                              </v-col>
                              <div v-for="tenant in tenantInfo" :key="tenant.id">
                                <v-col cols="12" sm="4" v-if="tenant.engineId == item.ID">
                                  <v-checkbox
                                    v-model="tenantSelected"
                                    :label="tenant.tenantName"
                                    :value="tenant.id"
                                    hide-details
                                    class="tenant-info"
                                  ></v-checkbox>
                                </v-col>
                              </div>                              
                            </v-row>
                          </div>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddUser()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmAddUser({userId, email, firstName, lastName, role, password1})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="addRemoteUserDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addRemoteUserTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5" v-html="addRemoteUserText"></div>
                        <v-form v-model="isFormValid" ref="addRemoteUserForm">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="password1"
                                :label="$t('ADMIN.USERS.FIELDS.PASS')"
                                :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                :rules="[rules.required, rules.password]"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                onpaste="return false"
                                v-model="password2"
                                :label="$t('ADMIN.USERS.FIELDS.CONFIRM_PASS')"
                                :append-icon="showPass2 ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass2 ? 'text' : 'password'"
                                @click:append="showPass2 = !showPass2"
                                :rules="password1 != '' ? [rules.required, rules.password, rules.passMatch] : []"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddRemoteUser()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmAddRemoteUser({password1})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="removeRemoteUserDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ removeRemoteUserTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5" v-html="removeRemoteUserText"></div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="removeRemoteUserDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmRemoveRemoteUser()"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.GROUPS.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchGroups"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.GROUPS.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="addGroup()"
                  >{{ $t('ADMIN.GROUPS.BTNS.ADD_GROUP') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="groupHeaders"
                  :items="allGroups"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchGroups"
                  class="elevation-1 group-list"
                  item-key="id"
                  :sort-by="groupsSortBy"
                  :sort-desc="groupsSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingGroups"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="success"
                      @click="editGroup(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="warning"
                      @click="addRemoveUsers(row.item)"
                    >
                      {{ $t('ADMIN.GROUPS.BTNS.ADD_REMOVE_USERS') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteGroup(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="editGroupDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ editGroupTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ editGroupText }}</div>

                        <v-form v-model="isFormValid">
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="groupId"
                                :label="$t('ADMIN.GROUPS.FIELDS.ID')"
                                disabled
                              >{{ groupId }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="groupName"
                                :label="$t('ADMIN.GROUPS.FIELDS.NAME')"
                                :rules="[rules.required]"
                              >{{ groupName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <div v-if="remoteGroupTenants.length > 0">
                            <v-row>
                              <v-col cols="12">
                                <div class="pt-5 pb-5">{{ $t('ADMIN.GROUPS.EDIT_GROUP.MULTI_INSTANCE_TOGGLE') }}</div>
                                <v-switch
                                  v-model="updateAllInstances"
                                  color="success"
                                  :label="$t('ADMIN.GROUPS.EDIT_GROUP.MULTI_INSTANCE_LABEL')"
                                ></v-switch>
                              </v-col>
                            </v-row>
                          </div>
                          <div v-if="allHqConns.length > 0">
                            <div class="pt-5 pb-5">{{ $t('ADMIN.GROUPS.EDIT_GROUP.MULTI_INSTANCE') }}</div>
                            <v-row v-for="item in allHqConns" :key="item.ID">
                              <v-col cols="12" sm="12">
                                <div class="engine-name text-subtitle-1">{{item.ENGINE_NAME}}</div>
                              </v-col>
                              <v-col cols="12" sm="6"  v-for="tenant in tenantInfo" :key="tenant.id">
                                <div v-if="tenant.engineId == item.ID">
                                  <v-checkbox
                                    v-model="tenantSelected"
                                    :label="tenant.tenantName"
                                    :value="tenant.id"
                                    hide-details
                                    class="tenant-info"
                                  ></v-checkbox>
                                </div>
                              </v-col>                              
                            </v-row>
                          </div>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelEditGroup()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmEditGroup({groupId, groupName})"
                        >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="deleteGroupDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ deleteGroupTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ deleteGroupText }}</div>
                        <div v-if="allHqConns.length > 0 && remoteGroupTenants.length > 0">
                          <div class="pt-5 pb-5">{{ $t('ADMIN.GROUPS.DELETE_GROUP.MULTI_INSTANCE') }}</div>
                          <v-row v-for="item in allHqConns" :key="item.ID">
                            <v-col cols="12" sm="4">
                              <div class="engine-name text-subtitle-1">{{item.ENGINE_NAME}}</div>
                            </v-col>
                            <div v-for="tenant in remoteGroupTenants" :key="tenant.id">
                              <v-col cols="12" sm="4" v-if="tenant.engineId == item.ID">
                                <v-checkbox
                                  v-model="tenantSelected"
                                  :label="tenant.tenantName"
                                  :value="tenant.id"
                                  hide-details
                                  class="tenant-info"
                                ></v-checkbox>
                              </v-col>
                            </div>                              
                          </v-row>
                        </div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="deleteGroupDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmDeleteGroup({groupId})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="addGroupDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addGroupTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ addGroupText }}</div>

                        <v-form v-model="isFormValid" ref="addGroupForm">
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="groupId"
                                :label="$t('ADMIN.GROUPS.FIELDS.ID')"
                                disabled
                              >{{ groupId }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="groupName"
                                :label="$t('ADMIN.GROUPS.FIELDS.NAME')"
                                :rules="[rules.required]"
                              >{{ groupName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <div v-if="allHqConns.length > 0">
                            <div class="pt-5 pb-5">{{ $t('ADMIN.GROUPS.ADD_GROUP.MULTI_INSTANCE') }}</div>
                            <v-row v-for="item in allHqConns" :key="item.ID">
                              <v-col cols="12" sm="12">
                                <div class="engine-name text-subtitle-1">{{item.ENGINE_NAME}}</div>
                              </v-col>
                              <v-col cols="12" sm="6" v-for="tenant in tenantInfo" :key="tenant.id">
                                <div v-if="tenant.engineId == item.ID">
                                  <v-checkbox
                                    v-model="tenantSelected"
                                    :label="tenant.tenantName"
                                    :value="tenant.id"
                                    hide-details
                                    class="tenant-info"
                                  ></v-checkbox>
                                </div>
                              </v-col>                              
                            </v-row>
                          </div>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddGroup()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmAddGroup({groupId, groupName})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="900"
                    v-model="addRemoveUsersDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addRemoveUsersTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ addRemoveUsersText }}</div>
                        <div v-if="remoteGroupTenants.length > 0">
                          <v-row>
                            <v-col cols="12">
                              <div class="pt-5 pb-5">{{ $t('ADMIN.GROUPS.ADD_REMOVE_USERS.MULTI_INSTANCE_TOGGLE') }}</div>
                              <v-switch
                                v-model="updateAllInstances"
                                color="success"
                                :label="$t('ADMIN.GROUPS.ADD_REMOVE_USERS.MULTI_INSTANCE_LABEL')"
                              ></v-switch>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-card-title>
                              {{ $t('ADMIN.GROUPS.ADD_REMOVE_USERS.AVAILABLE') }}
                              <v-spacer></v-spacer>
                              <v-btn
                                small
                                class="mr-2"
                                color="secondary"
                                @click="addUsersToGroup({availableSelected})"
                                :disabled="availableSelected.length == 0"
                              >{{ $t('ADMIN.GROUPS.ADD_REMOVE_USERS.BTNS.ADD_USERS') }}</v-btn>
                            </v-card-title>
                            <v-data-table
                              v-model="availableSelected"
                              :headers="addRemoveUsersHeaders"
                              :items="availableUsers"
                              :items-per-page="10"
                              class="elevation-1"
                              item-key="id"
                              sort-by="lastName"
                              :sort-desc="false"
                              loading-text="Loading... Please wait"
                              show-select
                            >

                            </v-data-table>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-card-title>
                              {{ $t('ADMIN.GROUPS.ADD_REMOVE_USERS.ASSIGNED') }}
                              <v-spacer></v-spacer>
                              <v-btn
                                small
                                class="mr-2"
                                color="secondary"
                                @click="removeUsersFromGroup({assignedSelected})"
                                :disabled="assignedSelected.length == 0"
                              >{{ $t('ADMIN.GROUPS.ADD_REMOVE_USERS.BTNS.REMOVE_USERS') }}</v-btn>
                            </v-card-title>
                            <v-data-table
                              v-model="assignedSelected"
                              :headers="addRemoveUsersHeaders"
                              :items="assignedUsers"
                              :items-per-page="10"
                              class="elevation-1"
                              item-key="id"
                              sort-by="lastName"
                              :sort-desc="false"
                              loading-text="Loading... Please wait"
                              show-select
                            >

                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddRemoveUsers()"
                        >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item v-if="theCurrentRole == 'adminRole'">
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.SETTINGS.ADMIN_SUPPORT.TITLE') }}
                </v-card-title>
                <v-form>
                  <v-card-subtitle>
                    {{ $t('ADMIN.SETTINGS.ADMIN_SUPPORT.DESC') }}
                  </v-card-subtitle>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="supportEmailAddress"
                        :type="'text'"
                        :label="$t('ADMIN.SETTINGS.ADMIN_SUPPORT.FIELDS.EMAIL')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-btn
                    depressed
                    color="success"
                    @click="saveSupportEmail()"
                  >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.SETTINGS.PROCESS_CONTROL.TITLE') }}
                </v-card-title>
                <v-form>
                  <v-card-subtitle>
                    {{ $t('ADMIN.SETTINGS.PROCESS_CONTROL.DESC') }}
                  </v-card-subtitle>
                  <v-row>
                    <v-col md="6">
                      <v-switch
                        v-model="enableUndeploy"
                        color="warning"
                        :label="$t('ADMIN.SETTINGS.PROCESS_CONTROL.UNDEPLOY_LABEL')"
                        @change="toggleUndeploy()"
                      ></v-switch>
                    </v-col>
                    <v-col md="6">
                      <v-switch
                        v-model="enableDeletion"
                        color="warning"
                        :label="$t('ADMIN.SETTINGS.PROCESS_CONTROL.DELETION_LABEL')"
                        @change="toggleDeletion()"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.SETTINGS.EMAIL_SERVER.TITLE') }}
                </v-card-title>
                <v-form :key="mailFormKey">
                  <v-row>
                    <v-col md="12">
                      <v-switch
                        v-model="isMSG"
                        color="success"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.MSG')"
                        @change="toggleMailType()"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="!isMSG">
                    <v-col md="4">
                      <v-text-field
                        v-model="serverDetails.emailHost"
                        :type="'text'"
                        name="emailHost"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.HOST')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="serverDetails.emailPort"
                        :type="'text'"
                        name="emailPort"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.PORT')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="serverDetails.emailSender"
                        :type="'text'"
                        name="emailSender"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.SENDER')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="!isMSG">
                    <v-col md="4">
                      <v-text-field
                        v-model="serverDetails.emailUsername"
                        :type="'text'"
                        name="emailUsername"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.USERNAME')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="serverDetails.emailPassword"
                        :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="showPass ? 'text' : 'password'"
                        name="emailPassword"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.PASS')"
                        @click:append="showPass = !showPass"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-switch
                        v-model="serverDetails.emailTls"
                        color="success"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.TLS_LABEL')"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="isMSG">
                    <v-col md="6">
                      <v-text-field
                        v-model="serverDetails.emailGraphClientId"
                        :type="'text'"
                        name="emailGraphClientId"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.GRAPH_CLIENT_ID')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        v-model="serverDetails.emailGraphClientSecret"
                        :type="'password'"
                        name="emailGraphClientSecret"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.GRAPH_CLIENT_SECRET')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isMSG">
                    <v-col md="6">
                      <v-text-field
                        v-model="serverDetails.emailGraphEmailId"
                        :type="'text'"
                        name="emailGraphEmailId"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.GRAPH_EMAIL_ID')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        v-model="serverDetails.emailGraphTenantId"
                        :type="'text'"
                        name="emailGraphTenantId"
                        :label="$t('ADMIN.SETTINGS.EMAIL_SERVER.FIELDS.GRAPH_TENANT_ID')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-btn
                    depressed
                    color="success"
                    @click="saveEmailServer()"
                  >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.SETTINGS.FILE_STORAGE.TITLE') }}
                </v-card-title>
                <v-form>
                  <v-card-subtitle>
                    {{ $t('ADMIN.SETTINGS.FILE_STORAGE.LOCAL') }}
                  </v-card-subtitle>
                  <v-row>
                    <v-col md="12">
                      <v-switch
                        v-model="storageDetails.localEnabled"
                        color="success"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.LOCAL_LABEL')"
                        @change="toggleStorage('local')"
                        :disabled="disableLocal"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-card-subtitle>
                    {{ $t('ADMIN.SETTINGS.FILE_STORAGE.OFFICE365') }}
                  </v-card-subtitle>
                  <v-row>
                    <v-col md="12">
                      <v-switch
                        v-model="storageDetails.officeEnabled"
                        color="success"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.OFFICE365_LABEL')"
                        @change="toggleStorage('office')"
                        :disabled="disableOffice"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4">
                      <v-text-field
                        v-model="storageDetails.officeTenantId"
                        :type="'text'"
                        name="officeTenantId"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.FIELDS.TENANT_ID')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="storageDetails.officeClientId"
                        :type="'text'"
                        name="officeClientId"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.FIELDS.CLIENT_ID')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="storageDetails.officeClientSecret"
                        :type="'text'"
                        name="officeClientSecret"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.FIELDS.CLIENT_SECRET')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="4">
                      <v-text-field
                        v-model="storageDetails.officeGroupName"
                        :type="'text'"
                        name="officeGroupName"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.FIELDS.GROUP_NAME')"
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="storageDetails.officeUploadPath"
                        :type="'text'"
                        name="officeUploadPath"
                        :label="$t('ADMIN.SETTINGS.FILE_STORAGE.FIELDS.UPLOAD_PATH')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-btn
                    depressed
                    color="success"
                    @click="saveStorageDetails()"
                  >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.CONNECTIONS.ENGINES.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchHqConns"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.CONNECTIONS.ENGINES.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="warning"
                    @click="refreshRemoteTenants()"
                  >{{ $t('ADMIN.CONNECTIONS.ENGINES.BTNS.REFRESH_TENANTS') }}</v-btn>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="addHqConnection()"
                  >{{ $t('ADMIN.CONNECTIONS.ENGINES.BTNS.ADD_CONNECTION') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="hqConnHeaders"
                  :items="allHqConns"
                  :items-per-page="10"
                  :search="searchHqConns"
                  class="elevation-1 conn-list"
                  item-key="ID"
                  :sort-by="hqConnSortBy"
                  :sort-desc="hqConnSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingConns"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="success"
                      @click="editHqConnection(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteHqConnection(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="editHqConnDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ editHqConnTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ editHqConnText }}</div>

                        <v-form v-model="isFormValid" ref="editHqConnForm">
                          <v-row>
                            <v-col cols="6" sm="12">
                              <v-text-field
                                v-model="hqUrl"
                                :label="$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ENGINE_URL')"
                                :rules="[rules.required]"
                              >{{ hqUrl }}</v-text-field>
                            </v-col>
                            <v-col cols="6" sm="12">
                              <v-text-field
                                v-model="hqName"
                                :label="$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ENGINE_NAME')"
                                :rules="[rules.required]"
                              >{{ hqName }}</v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelEditHqConnection()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmEditHqConnection({hqUrl, hqName})"
                        >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="400"
                    v-model="deleteHqConnDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ deleteHqConnTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ deleteHqConnText }}</div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="deleteHqConnDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmDeleteHqConnection()"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="addHqConnDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addHqConnTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ addHqConnText }}</div>

                        <v-form v-model="isFormValid" ref="addHqConnForm">
                          <v-row>
                            <v-col cols="6" sm="12">
                              <v-text-field
                                v-model="hqUrl"
                                :label="$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ENGINE_URL')"
                                :rules="[rules.required]"
                              >{{ hqUrl }}</v-text-field>
                            </v-col>
                            <v-col cols="6" sm="12">
                              <v-text-field
                                v-model="hqName"
                                :label="$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ENGINE_NAME')"
                                :rules="[rules.required]"
                              >{{ hqName }}</v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddHqConnection()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmAddHqConnection({hqUrl, hqName})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>

            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.CONNECTIONS.DATABASES.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchExternalDbs"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.CONNECTIONS.DATABASES.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="addDbConnection()"
                  >{{ $t('ADMIN.CONNECTIONS.DATABASES.BTNS.ADD_CONNECTION') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="extDbHeaders"
                  :items="allExtDbs"
                  :items-per-page="10"
                  :search="searchExternalDbs"
                  class="elevation-1 ext-list"
                  item-key="ID"
                  :sort-by="extDbSortBy"
                  :sort-desc="extDbSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingExts"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="success"
                      @click="editDbConnection(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteDbConnection(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="editDbDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ editDbTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ editDbText }}</div>

                        <v-form v-model="isFormValid">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-select
                                v-model="dbConnType"
                                :items="allDbTypes"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.CONN_TYPE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbName"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.DB_NAME')"
                                :rules="[rules.required]"
                              >{{ dbName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbIpAddr"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_NAME')"
                                :rules="[rules.required]"
                              >{{ dbIpAddr }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                type="number"
                                v-model="dbPort"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_PORT')"
                                :rules="[rules.required]"
                              >{{ dbPort }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbUser"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.USERNAME')"
                                :rules="[rules.required]"
                              >{{ dbUser }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbPass"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.PASS')"
                                :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelEditDbConnection()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmEditDbConnection({dbConnType, dbName, dbIpAddr, dbPort, dbUser, dbPass})"
                        >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="400"
                    v-model="deleteDbDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ deleteDbTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ deleteDbText }}</div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="deleteDbDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmDeleteDbConnection()"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="addDbDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addDbTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ addDbText }}</div>

                        <v-form v-model="isFormValid" ref="addDbForm">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-select
                                v-model="dbConnType"
                                :items="allDbTypes"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.CONN_TYPE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbName"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.DB_NAME')"
                                :rules="[rules.required]"
                              >{{ dbName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbIpAddr"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_NAME')"
                                :rules="[rules.required]"
                              >{{ dbIpAddr }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                type="number"
                                v-model="dbPort"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_PORT')"
                                :rules="[rules.required]"
                              >{{ dbPort }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbUser"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.USERNAME')"
                                :rules="[rules.required]"
                              >{{ dbUser }}</v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="dbPass"
                                :label="$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.PASS')"
                                :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddDbConnection()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmAddDbConnection({dbConnType, dbName, dbIpAddr, dbPort, dbUser, dbPass})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="connCheckDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ $t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.TITLE') }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ $t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.DESC') }}</div>
                        <v-btn
                          small
                          :color="loadingCheckColour"
                          width="100%"
                          :loading="loadingCheck"
                        >{{ connCheckStatus }}</v-btn>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="connCheckDialog = false"
                        >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.API_VAULT.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchApis"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.API_VAULT.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    class="mr-2"
                    color="secondary"
                    @click="addApi()"
                  >{{ $t('ADMIN.API_VAULT.BTNS.ADD_API') }}</v-btn>
                </v-card-title>
                <v-data-table
                  :headers="apiHeadings"
                  :items="allApis"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchApis"
                  class="elevation-1 api-list"
                  item-key="id"
                  :sort-by="apisSortBy"
                  :sort-desc="apisSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingApis"
                >
                  <template slot="item.actions" slot-scope="row">
                    <v-btn
                      small
                      class="mr-2"
                      color="success"
                      @click="editApi(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.EDIT') }}
                    </v-btn>
                    <v-btn
                      small
                      class="mr-2"
                      color="error"
                      @click="deleteApi(row.item)"
                    >
                      {{ $t('GENERAL.BTNS.DELETE') }}
                    </v-btn>
                  </template>
                </v-data-table>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="editApiDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ editApiTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ editApiText }}</div>

                        <v-form v-model="isFormValid">
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiName"
                                :label="$t('ADMIN.API_VAULT.FIELDS.FRIENDLY_NAME')"
                                :rules="[rules.required]"
                              >{{ apiName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-select
                                v-model="apiAuthType"
                                :items="allAuthTypes"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.API_VAULT.FIELDS.AUTH_TYPE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'basic'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="basicUser"
                                :label="$t('ADMIN.API_VAULT.FIELDS.USERNAME')"
                              >{{ basicUser }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'basic'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="basicPass"
                                :label="$t('ADMIN.API_VAULT.FIELDS.PASS')"
                                type="password"
                              >{{ basicPass }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'apiKey'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiKey"
                                :label="$t('ADMIN.API_VAULT.FIELDS.API_KEY')"
                              >{{ apiKey }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'apiKey'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiValue"
                                :label="$t('ADMIN.API_VAULT.FIELDS.API_VALUE')"
                                type="password"
                              >{{ apiValue }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'oAuth2'">
                            <v-col cols="12" sm="12">
                              <v-select
                                v-model="apiGrantType"
                                :items="allGrantTypes"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.API_VAULT.FIELDS.GRANT_TYPE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'oAuth2'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiClientId"
                                :label="$t('ADMIN.API_VAULT.FIELDS.CLIENT_ID')"
                                type="password"
                                :rules="[rules.required]"
                              >{{ apiClientId }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'oAuth2'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiClientSecret"
                                :label="$t('ADMIN.API_VAULT.FIELDS.CLIENT_SECRET')"
                                type="password"
                                :rules="[rules.required]"
                              >{{ apiClientSecret }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiEndpoint"
                                :label="$t('ADMIN.API_VAULT.FIELDS.ENDPOINT_URL')"
                                :rules="[rules.required]"
                              >{{ apiEndpoint }}</v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelEditApi()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmEditApi({apiId, apiName, apiAuthType, basicUser, basicPass, apiKey, apiValue, apiGrantType, apiClientId, apiClientSecret, apiEndpoint, apiHeaders})"
                        >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="deleteApiDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ deleteApiTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ deleteApiText }}</div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="deleteApiDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmDeleteApi({apiId})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="600"
                    v-model="addApiDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ addApiTitle }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ addApiText }}</div>

                        <v-form v-model="isFormValid" ref="addApiForm">
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiName"
                                :label="$t('ADMIN.API_VAULT.FIELDS.FRIENDLY_NAME')"
                                :rules="[rules.required]"
                              >{{ apiName }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-select
                                v-model="apiAuthType"
                                :items="allAuthTypes"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.API_VAULT.FIELDS.AUTH_TYPE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'basic'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="basicUser"
                                :label="$t('ADMIN.API_VAULT.FIELDS.USERNAME')"
                                autocomplete="new-password"
                              >{{ basicUser }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'basic'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="basicPass"
                                :label="$t('ADMIN.API_VAULT.FIELDS.PASS')"
                                type="password"
                                autocomplete="new-password"
                              >{{ basicPass }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'apiKey'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiKey"
                                :label="$t('ADMIN.API_VAULT.FIELDS.API_KEY')"
                                autocomplete="new-password"
                              >{{ apiKey }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'apiKey'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiValue"
                                :label="$t('ADMIN.API_VAULT.FIELDS.API_VALUE')"
                                type="password"
                                autocomplete="new-password"
                              >{{ apiValue }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'oAuth2'">
                            <v-col cols="12" sm="12">
                              <v-select
                                v-model="apiGrantType"
                                :items="allGrantTypes"
                                item-text="name"
                                item-value="val"
                                :label="$t('ADMIN.API_VAULT.FIELDS.GRANT_TYPE')"
                                :rules="[rules.required]"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'oAuth2'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiClientId"
                                :label="$t('ADMIN.API_VAULT.FIELDS.CLIENT_ID')"
                                type="password"
                                autocomplete="new-password"
                                :rules="[rules.required]"
                              >{{ apiClientId }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="apiAuthType == 'oAuth2'">
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiClientSecret"
                                :label="$t('ADMIN.API_VAULT.FIELDS.CLIENT_SECRET')"
                                type="password"
                                autocomplete="new-password"
                                :rules="[rules.required]"
                              >{{ apiClientSecret }}</v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-text-field
                                v-model="apiEndpoint"
                                :label="$t('ADMIN.API_VAULT.FIELDS.ENDPOINT_URL')"
                                :rules="[rules.required]"
                              >{{ apiEndpoint }}</v-text-field>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelAddApi()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          :disabled="!isFormValid"
                          @click="confirmAddApi({apiName, apiAuthType, basicUser, basicPass, apiKey, apiValue, apiGrantType, apiClientId, apiClientSecret, apiEndpoint, apiHeaders})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item v-if="theCurrentRole == 'adminRole'">
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.LDAP_SSO.LDAP.TITLE') }}
                </v-card-title>
                <v-form v-model="isFormValid">
                  <v-row>
                    <v-col md="6">
                      <v-switch
                        v-model="ssoDetails.ldapEnabled"
                        color="success"
                        :label="$t('ADMIN.LDAP_SSO.LDAP.TOGGLE')"
                        @change="toggleLdap()"
                      ></v-switch>
                    </v-col>
                    <v-col md="6" class="text-right">
                      <v-btn
                        v-if="showLdap"
                        class="mr-2"
                        depressed
                        color="warning" 
                        @click="ldapSelect('groups')"
                        :loading="loadingLdapGroups"
                      >{{ $t('ADMIN.LDAP_SSO.LDAP.BTNS.SYNC_GROUPS') }}</v-btn>
                      <v-btn
                        v-if="showLdap"
                        class="mr-2"
                        depressed
                        color="warning" 
                        @click="ldapSelect('users')"
                        :loading="loadingLdapUsers"
                      >{{ $t('ADMIN.LDAP_SSO.LDAP.BTNS.SYNC_USERS') }}</v-btn>
                      <v-btn
                        depressed
                        color="success"
                        @click="saveSsoDetails()"
                        :disabled="!isFormValid"
                      >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-card-subtitle>
                    {{ $t('ADMIN.LDAP_SSO.LDAP.DESC') }}
                  </v-card-subtitle>
                  <div v-if="showLdap">
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapServer"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.SERVER_ADDRESS')"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapPort"
                          :type="'number'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.SERVER_PORT')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapUsername"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.ADMIN_USER_DN')"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapPassword"
                          :type="'password'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.ADMIN_PASS')"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapBaseDn"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.BASE_DN')"
                          autocomplete="new-password"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapIdentifier"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.USER_IDENTIFIER')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapUsersCn"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.USERS_CN')"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.ldapGroupsCn"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.GROUPS_CN')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-switch
                          v-model="ssoDetails.ldapTls"
                          color="success"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.TLS_LABEL')"
                        ></v-switch>
                      </v-col>
                      <v-col md="6">
                        <v-switch
                          v-model="ssoDetails.ldapLoginEnabled"
                          color="success"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.LOGIN_TOGGLE')"
                          @change="toggleSso('ldap')"
                          :disabled="disableLdapLogin"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-switch
                          v-model="ldapAutoSync"
                          color="success"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.AUTO_SYNC')"
                        ></v-switch>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-if="ldapAutoSync"
                          v-model="ldapAutoSyncTime"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.LDAP.FIELDS.AUTO_SYNC_TIME')"
                          placeholder="* * * * *"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="1200"
                    v-model="ldapSelectGroupsDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ $t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.TITLE') }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ $t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.DESC') }}</div>
                      </v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-card-title>
                              {{ $t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.AVAILABLE') }}
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="ldapTreeSearch"
                                :label="$t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.AVAILABLE_SEARCH')"
                                single-line
                                hide-details
                                clearable
                              ></v-text-field>
                            </v-card-title>
                            <v-sheet
                              class="rounded"
                              elevation="1"
                            >
                              <v-treeview
                                v-model="availableLdapGroupsSelected"
                                selectable
                                :items="availableLdapTree"
                                item-key="id"
                                item-text="name"
                                :search="ldapTreeSearch"
                                open-on-click
                              >
                                <template v-slot:prepend="{ item }">
                                  <v-icon
                                    v-if="item.children"
                                  >{{ `mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}` }}</v-icon>
                                  <v-icon
                                    v-if="!item.children && item.id != 1"
                                  >{{ `mdi-account-multiple` }}</v-icon>
                                </template>
                              </v-treeview>
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelLdapSelect()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmLdapSelectGroups({availableLdapGroupsSelected})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="1200"
                    v-model="ldapSelectUsersDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ $t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.TITLE') }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ $t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.DESC') }}</div>
                      </v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-card-title>
                              {{ $t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.AVAILABLE') }}
                              <v-spacer></v-spacer>
                              <v-text-field
                              v-model="ldapUserSearch"
                              append-icon="mdi-magnify"
                              :label="$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.AVAILABLE_SEARCH')"
                              single-line
                              hide-details
                            ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              v-model="availableLdapUsersSelected"
                              :headers="ldapUsersHeaders"
                              :items="availableLdapUsers"
                              :items-per-page="10"
                              :search="ldapUserSearch"
                              class="elevation-1"
                              item-key="distinguishedName"
                              sort-by="sn"
                              :sort-desc="false"
                              loading-text="Loading... Please wait"
                              show-select
                            >

                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="cancelLdapSelect()"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          @click="confirmLdapSelectUsers({availableLdapUsersSelected})"
                        >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="1200"
                    v-model="ldapSyncingDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ $t('ADMIN.LDAP_SSO.LDAP.LDAP_SYNC.TITLE') }}</v-toolbar>
                      <v-card-text>
                        <div :loading="loadingLdapSync" class="pt-5">{{ $t('ADMIN.LDAP_SSO.LDAP.LDAP_SYNC.DESC') }}</div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="ldapSyncingDialog = false"
                        >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.LDAP_SSO.MSAL.TITLE') }}
                </v-card-title>
                <v-form>
                  <v-row>
                    <v-col md="6">
                      <v-switch
                        v-model="ssoDetails.msalEnabled"
                        color="success"
                        :label="$t('ADMIN.LDAP_SSO.MSAL.TOGGLE')"
                        @change="toggleSso('msal')"
                        :disabled="disableMsal"
                      ></v-switch>
                    </v-col>
                    <v-col md="6" class="text-right">
                      <v-btn
                        v-if="ssoDetails.msalEnabled"
                        class="mr-2"
                        depressed
                        color="secondary"
                        @click="msalDialog = !msalDialog"
                      >{{ $t('ADMIN.LDAP_SSO.MSAL.BTNS.HELP') }}</v-btn>
                      <v-btn
                        depressed
                        color="success"
                        @click="saveSsoDetails()"
                      >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-card-subtitle>
                    {{ $t('ADMIN.LDAP_SSO.MSAL.DESC') }}
                  </v-card-subtitle>
                  <div v-if="ssoDetails.msalEnabled">
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.msalClientId"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.MSAL.FIELDS.CLIENT_ID')"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.msalAuthority"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.MSAL.FIELDS.AUTHORITY')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.msalRedirectUri"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.MSAL.FIELDS.REDIRECT_URI')"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-switch
                          v-model="ssoDetails.msalAuthState"
                          color="success"
                          :label="$t('ADMIN.LDAP_SSO.MSAL.AUTH_STATE_LABEL')"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>

                <v-dialog
                    transition="dialog-bottom-transition"
                    max-width="800"
                    v-model="msalDialog"
                    :retain-focus="false"
                    persistent
                  >
                  <template>
                    <v-card>
                      <v-toolbar
                        color="#f87723"
                        dark
                      >{{ $t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.TITLE') }}</v-toolbar>
                      <v-card-text>
                        <div class="pt-5">{{ $t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.DESC') }}</div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_1')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_2')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_3')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_4')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_5')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_6')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_7')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_8')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_9')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_10')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_11')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_12')"></div>
                        <div v-html="$t('ADMIN.LDAP_SSO.MSAL.HELP_TEXT.HELP_TEXT_13')"></div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="msalDialog = false"
                        >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.LDAP_SSO.SAML.TITLE') }}
                </v-card-title>
                <v-form>
                  <v-row>
                    <v-col md="6">
                      <v-switch
                        v-model="ssoDetails.samlEnabled"
                        color="success"
                        :label="$t('ADMIN.LDAP_SSO.SAML.TOGGLE')"
                        @change="toggleSso('saml')"
                        :disabled="disableSaml"
                      ></v-switch>
                    </v-col>
                    <v-col md="6" class="text-right">
                      <v-btn
                        depressed
                        color="success"
                        @click="saveSsoDetails()"
                      >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-card-subtitle>
                    {{ $t('ADMIN.LDAP_SSO.SAML.DESC') }}
                  </v-card-subtitle>
                  <div v-if="ssoDetails.samlEnabled">
                    <v-row>
                      <v-col md="6">
                        <v-card-subtitle>
                          <b>{{ $t('ADMIN.LDAP_SSO.SAML.SP_TITLE') }}</b>
                        </v-card-subtitle>
                        <v-text-field
                          v-model="ssoDetails.samlSpId"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.SP_ENTITY_ID')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-card-subtitle>
                          <b>{{ $t('ADMIN.LDAP_SSO.SAML.IP_TITLE') }}</b>
                        </v-card-subtitle>
                        <v-text-field
                          v-model="ssoDetails.samlIpId"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.IP_ENTITY_ID')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlSpAcs"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.SP_REPLY_URL')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlIpSos"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.IP_SOS')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlSpSls"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.SP_SLS')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlIpSls"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.IP_SLS')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-card-subtitle>
                      <b>{{ $t('ADMIN.LDAP_SSO.SAML.CFG_TITLE') }}</b>
                    </v-card-subtitle>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlIpEmailAttr"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.IP_EMAIL_ATTR')"
                        ></v-text-field>
                      </v-col>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlIpFirstAttr"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.IP_FIRSTNAME_ATTR')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-text-field
                          v-model="ssoDetails.samlIpLastAttr"
                          :type="'text'"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.IP_LASTNAME_ATTR')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6">
                        <v-select
                          v-model="ssoDetails.samlSigAlg"
                          :items="sigAlgorithms"
                          item-text="name"
                          item-value="val"
                          :label="$t('ADMIN.LDAP_SSO.SAML.FIELDS.SIG_ALG_LABEL')"
                        ></v-select>
                      </v-col>
                      <v-col md="6" class="pt-8">
                        <v-file-input v-model="samlIpCert" :label="ssoDetails.samlIpCert.length > 0 ? $t('ADMIN.LDAP_SSO.SAML.FIELDS.CERT_EXISTS_LABEL') : $t('ADMIN.LDAP_SSO.SAML.FIELDS.CERT_UPLOAD_LABEL')"></v-file-input>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item v-if="theCurrentRole == 'adminRole'">
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.OPS_LOG.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchOpLog"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.OPS_LOG.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-row class="mx-2">
                  <v-col cols="12">
                    <v-switch
                      v-model="enablePentest"
                      color="error"
                      :label="enablePentest ? $t('ADMIN.OPS_LOG.PEN_TEST_MODE_ON') : $t('ADMIN.OPS_LOG.PEN_TEST_MODE_OFF')"
                      @change="togglePentest()"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="mx-2">
                  <v-col cols="12" lg="6" md="5">
                    <v-dialog
                      ref="logDateFrom"
                      v-model="logDateFrom"
                      :return-value.sync="dateFrom"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedDateFrom"
                          :label="$t('ADMIN.OPS_LOG.FIELDS.FROM_DATE')"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :locale="$t('GENERAL.LOCALE')"
                        v-model="dateFrom"
                        scrollable
                      >
                        
                        <v-btn
                          text
                          color="primary"
                          @click="logDateFrom = false"
                        >
                          {{ $t('GENERAL.BTNS.CANCEL') }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.logDateFrom.save(dateFrom)"
                        >
                          {{ $t('GENERAL.BTNS.SAVE') }}
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" lg="5" md="5">
                    <v-dialog
                      ref="logDateTo"
                      v-model="logDateTo"
                      :return-value.sync="dateTo"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="computedDateTo"
                          :label="$t('ADMIN.OPS_LOG.FIELDS.TO_DATE')"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :locale="$t('GENERAL.LOCALE')"
                        v-model="dateTo"
                        scrollable
                      >
                        
                        <v-btn
                          text
                          color="primary"
                          @click="logDateTo = false"
                        >
                          {{ $t('GENERAL.BTNS.CANCEL') }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.logDateTo.save(dateTo)"
                        >
                          {{ $t('GENERAL.BTNS.SAVE') }}
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="12" lg="1" md="2">
                    <v-btn
                      class="mt-3"
                      color="primary"
                      @click="refreshOpLog()"
                    >
                      {{ $t('ADMIN.OPS_LOG.BTNS.REFRESH') }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="opLogHeaders"
                  :items="operationLog"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchOpLog"
                  class="elevation-1 op-list"
                  item-key="ID"
                  :sort-by="opLogSortBy"
                  :sort-desc="opLogSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingOps"
                >
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card>
                <v-card-title>
                  {{ $t('ADMIN.ERROR_LOG.TITLE') }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchErrorLog"
                    append-icon="mdi-magnify"
                    :label="$t('ADMIN.ERROR_LOG.SEARCH_TEXT')"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mt-3 mr-3"
                    color="primary"
                    @click="refreshErrorLog()"
                  >
                    {{ $t('ADMIN.ERROR_LOG.BTNS.REFRESH') }}
                  </v-btn>
                  <v-btn
                    class="mt-3"
                    color="error"
                    @click="clearErrorLog()"
                  >
                    {{ $t('ADMIN.ERROR_LOG.BTNS.CLEAR') }}
                  </v-btn>
                </v-card-title>
                <v-data-table
                  :headers="errorLogHeaders"
                  :items="errorLog"
                  :items-per-page="25"
                  :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
                  :search="searchErrorLog"
                  class="elevation-1 op-list"
                  item-key="ID"
                  :sort-by="errorLogSortBy"
                  :sort-desc="errorLogSortDesc"
                  loading-text="Loading... Please wait"
                  :loading="loadingErrors"
                >
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>

      <v-tab-item v-if="theCurrentRole == 'adminRole'">
        <v-container class="width-override">
          <v-row>
            <v-col md="12">
              <v-card class="pa-5">
                <v-card-title>
                  {{ $t('ADMIN.LICENSE.TITLE') }}
                </v-card-title>
                <v-form v-model="isFormValid" ref="licenseForm">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="licenseStart"
                        :label="$t('ADMIN.LICENSE.START_DATE')"
                        disabled
                      >{{ licenseStart }}</v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="licenseExpiry"
                        :label="$t('ADMIN.LICENSE.END_DATE')"
                        disabled
                      >{{ licenseExpiry }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        rows="2"
                        v-model="licenseKey"
                        :label="$t('ADMIN.LICENSE.KEY_TEXT')"
                        :rules="[rules.required, rules.minLength]"
                      ></v-textarea>
                      <v-btn
                        class="mr-2"
                        color="success"
                        @click="updateLicense()"
                        :disabled="!isFormValid"
                      >{{ $t('ADMIN.LICENSE.KEY_BTN') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>

    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  import cryptojs from 'crypto-js';
  export default {
    name: 'admin',
    computed: {
      ...mapGetters(['serverDetails', 'storageDetails', 'ssoDetails', 'allUsers', 'allGroups', 'allRoles', 'availableUsers', 'assignedUsers', 'userErrorMsg', 'allExtDbs', 'operationLog', 'allApis', 'operationLogError', 'allHqConns', 'tenantInfo', 'checkEngine', 'tenantsAdded', 'remoteAddedUser', 'remoteAddedPortal', 'remoteAddedToRole', 'remoteDeletedUser', 'remoteUserTenants', 'remoteAddedGroup', 'remoteGroupTenants', 'remoteDeletedGroup', 'remoteUpdatedGroup', 'licenseStartDate', 'licenseExpiryDate', 'enableProcessUndeploy', 'enableProcessDeletion', 'enablePentestMode', 'supportEmail', 'dbConnAdded', 'dbConnEdited', 'apiAdded', 'apiUpdated', 'apiDeleted', 'availableLdapUsers', 'availableLdapGroups', 'availableLdapTree', 'ldapSyncGroupData', 'ldapSyncUserData', 'ldapStoreStatus', 'ldapSelectStatus', 'ldapGroupUserAdded', 'ldapSelectedData', 'errorLog', 'errorLogError']),
      computedDateFrom () {
        return this.formatDate(this.dateFrom)
      },
      computedDateTo () {
        return this.formatDate(this.dateTo)
      }
    },
    data: function() {
      return {
        tab: null,
        licenseStart: null,
        licenseExpiry: null,
        licenseKey: null,
        enableUndeploy: false,
        enableDeletion: false,
        enablePentest: false,
        emailHost: null,
        emailPort: null,
        emailSender: null,
        emailUsername: null,
        emailPassword: null,
        emailTls: null,
        isMSG: false,
        mailFormKey: 0,
        isFormValid: false,
        editUserDialog: false,
        editUserTitle: '',
        editUserText: '',
        deleteUserDialog: false,
        deleteUserTitle: '',
        deleteUserText: '',
        addUserDialog: false,
        addUserTitle: '',
        addUserText: '',
        passwordPolicy: '',
        editGroupDialog: false,
        editGroupTitle: '',
        editGroupText: '',
        deleteGroupDialog: false,
        deleteGroupTitle: '',
        deleteGroupText: '',
        addGroupDialog: false,
        addGroupTitle: '',
        addGroupText: '',
        addRemoveUsersDialog: false,
        addRemoveUsersTitle: '',
        addRemoveUsersText: '',
        editApiDialog: false,
        editApiTitle: '',
        editApiText: '',
        deleteApiDialog: false,
        deleteApiTitle: '',
        deleteApiText: '',
        addApiDialog: false,
        addApiTitle: '',
        addApiText: '',
        apiId: 0, 
        apiName: '', 
        apiAuthType: '', 
        basicUser: '', 
        basicPass: '', 
        apiKey: '', 
        apiValue: '', 
        apiGrantType: '', 
        apiClientId: '', 
        apiClientSecret: '', 
        apiEndpoint: '', 
        apiHeaders: '',
        searchUsers: '',
        searchGroups: '',
        searchApis: '',
        userId: '',
        role: null,
        currentRole: null,
        groupId: '',
        groupName: '',
        email: '',
        firstName: '',
        lastName: '',
        password1: '',
        password2: '',
        showPass: false,
        showPass2: false,
        availableSelected: [],
        assignedSelected: [],
        usersSortBy: '',
        usersSortDesc: false,
        groupsSortBy: '',
        groupsSortDesc: false,
        apisSortBy: '',
        apisSortDesc: false,
        searchExternalDbs: '',
        extDbSortBy: '',
        extDbSortDesc: false,
        searchOpLog: '',
        opLogSortBy: '',
        opLogSortDesc: false,
        logDateFrom: '',
        dateFrom: '',
        logDateTo: '',
        dateTo: '',
        searchErrorLog: '',
        errorLogSortBy: 'ID',
        errorLogSortDesc: true,
        addDbDialog: false,
        addDbTitle: '',
        addDbText: '',
        editDbDialog: false,
        editDbTitle: '',
        editDbText: '',
        deleteDbDialog: false,
        deleteDbTitle: '',
        deleteDbText: '',
        connCheckDialog: false,
        connCheckStatus: '',
        loadingCheck: false,
        loadingCheckColour: '',
        dbConnType: null,
        dbName: '',
        dbIpAddr: '',
        dbPort: null,
        dbUser: '',
        dbPass: '',
        dbConnId: '',
        searchHqConns: '',
        hqConnSortBy: '',
        hqConnSortDesc: false,
        addHqConnDialog: false,
        addHqConnTitle: '',
        addHqConnText: '',
        editHqConnDialog: false,
        editHqConnTitle: '',
        editHqConnText: '',
        deleteHqConnDialog: false,
        deleteHqConnTitle: '',
        deleteHqConnText: '',
        tenantSelected: [],
        existingTenants: [],
        addRemoteUserPayload: {},
        addRemoteUserDialog: false,
        addRemoteUserTitle: '',
        addRemoteUserText: '',
        removeRemoteUserDialog: false,
        removeRemoteUserTitle: '',
        removeRemoteUserText: '',
        removeRemoteUserId: '',
        removeFromTenant: [],
        userAction: '',
        groupAction: '',
        updateAllInstances: null,
        hqUrl: '',
        hqName: '',
        hqConnId: '',
        disableOffice: false,
        disableLocal: false,
        disableMsal: false,
        disableSaml: false,
        disableLdapLogin: false,
        msalDialog: false,
        ldapSelectGroupsDialog: false,
        ldapSelectUsersDialog: false,
        ldapUserSearch: '',
        ldapGroupSearch: '',
        ldapTreeSearch: '',
        ldapSyncingDialog: false,
        loadingLdapGroups: false,
        loadingLdapUsers: false,
        loadingLdapSync: false,
        showLdap: false,
        ldapAutoSync: false,
        ldapAutoSyncTime: '',
        samlIpCert: [],
        supportEmailAddress: '',
        rules: {
          required: value => !!value || 'Required',
          minLength: value => {
            if(value) {
              return value.length >= 192 || 'Key is too short'
            }else {
              return true
            }
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
          password: value => {
            if(value != '') {
              const pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{10,}$/
              return pattern.test(value) || 'Passwords must meet the following criteria: Min 10 characters with at least 1 uppercase letter, 1 lowercase letter, 1 digit and 1 special character.'
            }else {
              return true;
            }
          },
          passMatch: value => value === this.password1 && value === this.password2 || 'The passwords do not match',
          groupId: value => {
            const pattern = /^[a-zA-Z0-9]*$/
            return pattern.test(value) || 'The group ID can only contain letters and numbers, no spaces or special characters.'
          }
        },
        theCurrentUser: this.$store.state.currentUser,
        theCurrentRole: this.$store.state.currentRole,
        userHeaders: [
          {
            text: this.$t('ADMIN.USERS.FIELDS.FIRSTNAME'),
            align: 'start',
            sortable: true,
            value: 'firstName',
          },
          { text: this.$t('ADMIN.USERS.FIELDS.LASTNAME'), value: 'lastName', sortable: true },
          { text: this.$t('ADMIN.USERS.FIELDS.USERNAME'), value: 'id', sortable: true },
          { text: this.$t('ADMIN.USERS.FIELDS.ROLE'), value: 'roleName', sortable: true },
          { text: this.$t('ADMIN.USERS.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        loadingUsers: false,
        loadingGroups: false,
        loadingConns: false,
        loadingExts: false,
        loadingApis: false,
        loadingOps: false,
        loadingErrors: false,
        groupHeaders: [
          {
            text: this.$t('ADMIN.GROUPS.FIELDS.NAME'),
            align: 'start',
            sortable: true,
            value: 'name',
          },
          { text: this.$t('ADMIN.GROUPS.FIELDS.ID'), value: 'id', sortable: true },
          { text: this.$t('ADMIN.GROUPS.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        addRemoveUsersHeaders: [
          {
            text: this.$t('ADMIN.GROUPS.FIELDS.FIRSTNAME'),
            align: 'start',
            sortable: true,
            value: 'firstName',
          },
          { text: this.$t('ADMIN.GROUPS.FIELDS.LASTNAME'), value: 'lastName', sortable: true }
        ],
        extDbHeaders: [
          { text: this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.CONN_TYPE'), value: 'CONN_TYPE_TITLE', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.DB_NAME'), value: 'DB_NAME', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_NAME'), value: 'DB_IP_ADDR', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_PORT'), value: 'DB_PORT', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        allDbTypes: [
          { name: 'MySQL', val: 'mysql' },
          { name: 'Postgres', val: 'postgresql' },
          { name: 'MSSQL', val: 'mssql' },
          { name: 'Azure (MSSQL)', val: 'sqlserver' },
          { name: 'Oracle', val: 'oracle' }
        ],
        hqConnHeaders: [
          { text: this.$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ENGINE_URL'), value: 'URL', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ENGINE_NAME'), value: 'ENGINE_NAME', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.TENANTS'), value: 'TENANTS', sortable: true },
          { text: this.$t('ADMIN.CONNECTIONS.ENGINES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        apiHeadings: [
          { text: this.$t('ADMIN.API_VAULT.FIELDS.ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('ADMIN.API_VAULT.FIELDS.FRIENDLY_NAME'), value: 'FRIENDLY_NAME', sortable: true },
          { text: this.$t('ADMIN.API_VAULT.FIELDS.AUTH_TYPE'), value: 'AUTH_TYPE', sortable: true },
          { text: this.$t('ADMIN.API_VAULT.FIELDS.ENDPOINT_URL'), value: 'ENDPOINT_URL', sortable: true },
          { text: this.$t('ADMIN.API_VAULT.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        allAuthTypes: [
          { name: 'None', val: 'none' },
          { name: 'Basic', val: 'basic' },
          { name: 'API Key', val: 'apiKey' },
          { name: 'OAuth 2.0', val: 'oAuth2' }
        ],
        allGrantTypes: [
          { name: 'Client Credentials', val: 'client_credentials' },
          // { name: 'Authorization Code', val: 'authorization_code' },
          // { name: 'Refresh Token', val: 'refresh_token' }
        ],
        sigAlgorithms: [
          { name: 'RSA SHA-1', val: 'rsa-sha1' },
          { name: 'RSA SHA-256', val: 'rsa-sha256' }
        ],
        availableLdapUsersSelected: [],
        ldapUsersHeaders: [
          {
            text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.FIRSTNAME'),
            align: 'start',
            sortable: true,
            value: 'givenName',
          },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.LASTNAME'), value: 'sn', sortable: true },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.USERNAME'), value: 'sAMAccountName', sortable: true },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.EMAIL'), value: 'mail', sortable: true },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.DN'), value: 'distinguishedName', sortable: false },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.CN'), value: 'cn', sortable: false },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_USERS.FIELDS.MEMBER_OF'), value: 'memberOf', sortable: false }
        ],
        availableLdapGroupsSelected: [],
        ldapGroupsHeaders: [
          {
            text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.FIELDS.NAME'),
            align: 'start',
            sortable: true,
            value: 'sAMAccountName',
          },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.FIELDS.DN'), value: 'distinguishedName', sortable: false },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.FIELDS.CN'), value: 'cn', sortable: false },
          { text: this.$t('ADMIN.LDAP_SSO.LDAP.SYNC_GROUPS.FIELDS.MEMBERS'), value: 'member', sortable: false }
        ],
        opLogHeaders: [
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.CATEGORY'), value: 'CATEGORY', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.OPERATION'), value: 'OPERATION', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.CASE_ID'), value: 'CASE_ID', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.PROCESS_NAME'), value: 'PROCESS_NAME', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.TASK_NAME'), value: 'TASK_NAME', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.USER_ID'), value: 'USER_ID', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.MESSAGE'), value: 'MSG', sortable: true },
          { text: this.$t('ADMIN.OPS_LOG.FIELDS.DATE_TIME'), value: 'DATE_TIME', sortable: false }
        ],
        errorLogHeaders: [
          { text: this.$t('ADMIN.ERROR_LOG.FIELDS.ID'), align: 'start', sortable: true, value: 'ID' },
          { text: this.$t('ADMIN.ERROR_LOG.FIELDS.ERROR_TYPE'), value: 'ERROR_TYPE', sortable: true },
          { text: this.$t('ADMIN.ERROR_LOG.FIELDS.ERROR_MSG'), value: 'ERROR_MSG', sortable: true },
          { text: this.$t('ADMIN.ERROR_LOG.FIELDS.ERROR_DUMP'), value: 'ERROR_DUMP', sortable: false },
          { text: this.$t('ADMIN.ERROR_LOG.FIELDS.MAPPED_VAR'), value: 'MAPPED_VAR', sortable: true },
          { text: this.$t('ADMIN.ERROR_LOG.FIELDS.LOGGED_ON'), value: 'LOGGED_ON', sortable: true }
        ],
        snack: false,
        snackColor: '',
        snackText: '',
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'LICENSE_START_DATE') {
          this.licenseStart = this.licenseStartDate;
        }

        if(mutation.type === 'LICENSE_EXPIRY_DATE') {
          this.licenseExpiry = this.licenseExpiryDate;
        }

        if(mutation.type === 'SUPPORT_EMAIL') {
          this.supportEmailAddress = this.supportEmail;
        }

        if(mutation.type === 'ENABLE_PROCESS_UNDEPLOY') {
          this.enableUndeploy = JSON.parse(this.enableProcessUndeploy);
        }

        if(mutation.type === 'ENABLE_PROCESS_DELETION') {
          this.enableDeletion = JSON.parse(this.enableProcessDeletion);
        }

        if(mutation.type === 'ENABLE_PENTEST_MODE') {
          this.enablePentest = JSON.parse(this.enablePentestMode);
        }

        if(mutation.type === 'SERVER_DETAILS') {
          if(this.serverDetails.emailType == 'msg') {
            this.isMSG = true;
          }else {
            this.isMSG = false;
          }
        }

        if(mutation.type === 'USER_ERROR_MESSAGE') {
          this.snackErrorMessage();
        }

        if(mutation.type === 'OP_LOG_ERROR_MSG') {
          this.snackOpLogError();
        }

        if(mutation.type === 'ERROR_LOG_ERROR_MSG') {
          this.snackErrorLogError();
        }
        
        if(mutation.type === 'DB_CONN_ADDED' || mutation.type === 'DB_CONN_EDITED' || mutation.type === 'DB_CONN_DELETED') {
          this.refreshConnections();

          if(mutation.type === 'DB_CONN_ADDED') {
            if(this.dbConnAdded == 'success') {
              this.loadingCheck = false;
              this.loadingCheckColour = 'success';
              this.connCheckStatus = this.$t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.STATUS.SUCCESS');
            }else {
              this.loadingCheck = false;
              this.loadingCheckColour = 'error';
              this.connCheckStatus = this.$t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.STATUS.FAIL');
            }
          }

          if(mutation.type === 'DB_CONN_EDITED') {
            if(this.dbConnEdited == 'success') {
              this.loadingCheck = false;
              this.loadingCheckColour = 'success';
              this.connCheckStatus = this.$t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.STATUS.SUCCESS');
            }else {
              this.loadingCheck = false;
              this.loadingCheckColour = 'error';
              this.connCheckStatus = this.$t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.STATUS.FAIL');
            }
          }
        }

        if(mutation.type === 'CHECK_ENGINE') {
          if(!this.checkEngine) {
            this.snackEngineError();
          }
        }

        if(mutation.type === 'TENANTS_ADDED') {
          if(!this.tenantsAdded) {
            this.snackTenantError();
          }
        }
        
        if(mutation.type === 'TENANTS_ADDED' || mutation.type === 'HQ_CONN_ADDED' || mutation.type === 'HQ_CONN_EDITED' || mutation.type === 'HQ_CONN_DELETED') {
          this.refreshHqConnections();
        }

        if(mutation.type === 'API_ADDED') {
          if(!this.apiAdded) {
            this.snackMiscError('The API could not be added.');
          }else {
            this.snackMiscSuccess('The API was added successfully.');
          }
          this.refreshApis();
        }

        if(mutation.type === 'API_UPDATED') {
          if(!this.apiUpdated) {
            this.snackMiscError('The API could not be updated.');
          }else {
            this.snackMiscSuccess('The API was updated successfully.');
          }
          this.refreshApis();
        }

        if(mutation.type === 'API_DELETED') {
          if(!this.apiDeleted) {
            this.snackMiscError('The API could not be deleted.');
          }else {
            this.snackMiscSuccess('The API was deleted successfully.');
          }
          this.refreshApis();
        }

        if(mutation.type === 'OP_LOG_UPDATED') {
          this.refreshOpLog();
        }

        if(mutation.type === 'REMOTE_ADDED_USER') {
          if(this.remoteAddedUser.success) {
            this.snackRemoteUserOk(this.remoteAddedUser.msg);
            this.updateLog('Admin', 'Created', this.remoteAddedUser.log);
          }else {
            this.snackRemoteUserFail(this.remoteAddedUser.msg);
          }
        }

        if(mutation.type === 'REMOTE_ADDED_PORTAL') {
          if(!this.remoteAddedPortal.success) {
            this.snackRemoteUserFail(this.remoteAddedPortal.msg);
          }
        }

        if(mutation.type === 'REMOTE_ADDED_TO_ROLE') {
          if(this.remoteAddedToRole.success) {
            this.updateLog('Admin', 'Created', this.remoteAddedToRole.log);
          }else {
            this.snackRemoteRoleFail();
          }
        }

        if(mutation.type === 'REMOTE_DELETED_USER') {
          if(this.remoteDeletedUser == '') {
            this.snackRemoteUserFail('Remote user deletion failed');
          }
        }

        if(mutation.type === 'REMOTE_USER_TENANTS') {
          if(this.userAction == 'delete') {
            this.showDeleteDialog();
          }
          if(this.userAction == 'edit') {
            this.showEditDialog();
          }
        }

        if(mutation.type === 'REMOTE_ADDED_GROUP') {
          if(this.remoteAddedGroup.success) {
            this.snackRemoteUserOk(this.remoteAddedGroup.msg);
            this.updateLog('Admin', 'Created', this.remoteAddedGroup.log);
          }else {
            this.snackRemoteUserFail(this.remoteAddedGroup.msg);
          }
        }

        if(mutation.type === 'REMOTE_GROUP_TENANTS') {
          if(this.groupAction == 'delete') {
            this.showDeleteGroupDialog();
          }
          if(this.groupAction == 'edit') {
            this.showEditGroupDialog();
          }
        }

        if(mutation.type === 'REMOTE_DELETED_GROUP') {
          if(this.remoteDeletedGroup == '') {
            this.snackRemoteUserFail('Remote group deletion failed');
          }
        }

        if(mutation.type === 'REMOTE_UPDATED_GROUP') {
          if(this.remoteUpdatedGroup == '') {
            this.snackRemoteUserFail('Remote group update failed');
          }
        }

        if(mutation.type === 'SSO_DETAILS') {
          if(this.ssoDetails.ldapEnabled) {
            this.toggleSso('ldap');
            this.showLdap = true;
          }
          if(this.ssoDetails.msalEnabled) {
            this.toggleSso('msal');
          }
          if(this.ssoDetails.samlEnabled) {
            this.toggleSso('saml');
          }
          if(this.ssoDetails.ldapAutoSync) {
            this.ldapAutoSync = this.ssoDetails.ldapAutoSync;
          }
          if(this.ssoDetails.ldapAutoSyncTime) {
            this.ldapAutoSyncTime = this.ssoDetails.ldapAutoSyncTime;
          }
        }

        if(mutation.type === 'LDAP_STORE_STATUS') {
          if(!this.ldapStoreStatus) {
            this.snackMiscError('The selected LDAP users/groups could not be saved.');
          }else {
            this.snackMiscSuccess('The selected LDAP users/groups were saved successfully.');
          }
        }

        if(mutation.type === 'LDAP_SELECT_STATUS') {
          if(!this.ldapSelectStatus) {
            this.snackMiscError('Unable to retrieve LDAP data.');
          }
        }

        if(mutation.type === 'LDAP_SELECTED_DATA') {
          // Check for group items
          const findItemNested = (arr, itemName, nestingKey) => (
            arr.reduce((a, item) => {
              if (a) return a;
              if (item.data && item.data.objectGUID === itemName) return item;
              if (item[nestingKey]) return findItemNested(item[nestingKey], itemName, nestingKey)
            }, null)
          );

          // Preselect Groups
          for(let i = 0; i < this.ldapSelectedData.currentLdapGroupsSelected.length; i++) {
            let itemFound = findItemNested(this.availableLdapTree, this.ldapSelectedData.currentLdapGroupsSelected[i].objectGUID, "children");
            this.availableLdapGroupsSelected.push(itemFound.id);
          }

          // Preselect Users
          for(let i = 0; i < this.ldapSelectedData.currentLdapUsersSelected.length; i++) {
            for(let j = 0; j < this.availableLdapUsers.length; j++) {
              if(this.ldapSelectedData.currentLdapUsersSelected[i].objectGUID == this.availableLdapUsers[j].objectGUID) {
                this.availableLdapUsersSelected.push(this.availableLdapUsers[j]);
              }
            }
          }

          this.showLdapSelect(this.ldapSelectedData.type);
        }

        if(mutation.type === 'LDAP_USER_ADDED' || mutation.type === 'LDAP_GROUP_USERS_ADDED' || mutation.type === 'DELETED_USER') {
          this.refreshUsers();
        }

        if(mutation.type === 'DELETED_GROUP') {
          this.refreshGroups();
        }
      });

      let supportPayload = { 'action': 'get' };
      this.$store.dispatch('supportSettings', supportPayload);
      let payload = { 'action': 'getAll' };
      this.$store.dispatch('processSettings', payload);
      this.$store.dispatch('getServerDetails');
      this.$store.dispatch('getStorageDetails');
      this.$store.dispatch('getSsoDetails');
      this.$store.dispatch('getAllRoles');
      this.$store.dispatch('getLicense');
      // this.refreshUsers();
      // this.refreshGroups();
      // this.refreshHqConnections();
      // this.refreshConnections();
      // this.refreshApis();
      // this.refreshOpLog();

      if(this.storageDetails.localEnabled) {
        this.disableOffice = true;
      }
      if(this.storageDetails.officeEnabled) {
        this.disableLocal = true;
      }
    },
    watch: {
      tab(newVal) {        
        if(newVal == 0) {
          this.refreshUsers();
        }
        if(newVal == 1) {
          this.refreshGroups();
        }
        if(newVal == 3) {
          this.refreshHqConnections();
          this.refreshConnections();
        }
        if(newVal == 4) {
          this.refreshApis();
        }
        if(newVal == 6) {
          this.refreshOpLog();
        }
        if(newVal == 7) {
          this.refreshErrorLog();
        }
      },
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      updateLicense() {
        let key = this.licenseKey.replace(/\s/g, '');

        this.$store.dispatch('setLicense', key).then( () => {
          this.licenseKey = null;
          this.$refs.licenseForm.resetValidation();
        });
      },
      togglePentest() {
        let payload = {
          'action': 'pentest',
          'enablePentest': this.enablePentest
        };

        this.$store.dispatch('processSettings', payload);
      },
      toggleUndeploy() {
        let payload = {
          'action': 'deploy',
          'enableUndeploy': this.enableUndeploy
        };

        this.$store.dispatch('processSettings', payload);
      },
      toggleDeletion() {
        let payload = {
          'action': 'deletion',
          'enableDeletion': this.enableDeletion
        };

        this.$store.dispatch('processSettings', payload);
      },
      saveSupportEmail() {
        let payload = {
          'action': 'set',
          'supportEmail': this.supportEmailAddress
        };

        this.$store.dispatch('supportSettings', payload);
      },
      toggleStorage(item) {
        if(item == 'local') {
          if(this.storageDetails.localEnabled) {
            this.storageDetails.officeEnabled = false;
            this.disableOffice = true;
          }else {
            this.disableOffice = false;
          }
        }
        if(item == 'office') {
          if(this.storageDetails.officeEnabled) {
            this.storageDetails.localEnabled = false;
            this.disableLocal = true;
          }else {
            this.disableLocal = false;
          }
        }
      },
      async toggleMailType() {
        if(this.isMSG) {
          this.serverDetails.emailType = 'msg';
        }else {
          this.serverDetails.emailType = 'smtp';
        }
      },
      saveEmailServer () {
        let payload = {};
        
        if(this.isMSG) {
          payload = {
            'emailGraphClientId': this.serverDetails.emailGraphClientId,
            'emailGraphClientSecret': this.serverDetails.emailGraphClientSecret,
            'emailGraphEmailId': this.serverDetails.emailGraphEmailId,
            'emailGraphTenantId': this.serverDetails.emailGraphTenantId,
            'emailType': this.serverDetails.emailType
          };
        }else {
          payload = {
            'emailHost': this.serverDetails.emailHost,
            'emailPort': this.serverDetails.emailPort,
            'emailTls': this.serverDetails.emailTls,
            'emailSender': this.serverDetails.emailSender,
            'emailUsername': this.serverDetails.emailUsername,
            'emailPassword': this.serverDetails.emailPassword,
            'emailType': this.serverDetails.emailType
          };
        }
        
        this.$store.dispatch('saveServerDetails', payload).then( () => {
          this.updateLog('Admin', 'Updated', 'Email server updated.');
          this.snackSave();
        });
      },
      saveStorageDetails () {
        let payload = {
          'localEnabled': this.storageDetails.localEnabled,
          'officeEnabled': this.storageDetails.officeEnabled,
          'officeTenantId': this.storageDetails.officeTenantId,
          'officeClientId': this.storageDetails.officeClientId,
          'officeClientSecret': this.storageDetails.officeClientSecret,
          'officeGroupName': this.storageDetails.officeGroupName,
          'officeUploadPath': this.storageDetails.officeUploadPath
        };
        
        this.$store.dispatch('saveStorageDetails', payload).then( () => {
          this.updateLog('Admin', 'Updated', 'Storage details updated.');
          this.snackSave();
        });
      },
      toggleLdap() {
        if(this.showLdap) {
          this.showLdap = false;
        }else {
          this.showLdap = true;
        }
      },
      toggleSso(item) {
        if(item == 'msal') {
          if(this.ssoDetails.msalEnabled) {
            this.ssoDetails.samlEnabled = false;
            this.ssoDetails.ldapLoginEnabled = false;
            this.disableSaml = true;
            this.disableLdapLogin = true;
          }else {
            this.disableSaml = false;
            this.disableLdapLogin = false;
          }
        }
        if(item == 'saml') {
          if(this.ssoDetails.samlEnabled) {
            this.ssoDetails.msalEnabled = false;
            this.ssoDetails.ldapLoginEnabled = false;
            this.disableMsal = true;
            this.disableLdapLogin = true;
          }else {
            this.disableMsal = false;
            this.disableLdapLogin = false;
          }
        }
        if(item == 'ldap') {
          if(this.ssoDetails.ldapLoginEnabled) {
            this.ssoDetails.msalEnabled = false;
            this.ssoDetails.samlEnabled = false;
            this.disableMsal = true;
            this.disableSaml = true;
          }else {
            this.disableMsal = false;
            this.disableSaml = false;
          }
        }
      },
      async saveSsoDetails() {
        let fileContent = '';
        let payload = {};

        if(this.samlIpCert.name) {
          (async () => {
            fileContent = await this.samlIpCert.text();
            
            payload = {
              'msalEnabled': this.ssoDetails.msalEnabled,
              'msalClientId': this.ssoDetails.msalClientId,
              'msalAuthority': this.ssoDetails.msalAuthority,
              'msalRedirectUri': this.ssoDetails.msalRedirectUri,
              'msalAuthState': this.ssoDetails.msalAuthState,
              'samlEnabled': this.ssoDetails.samlEnabled,
              'samlIpId': this.ssoDetails.samlIpId,
              'samlIpSls': this.ssoDetails.samlIpSls,
              'samlIpSos': this.ssoDetails.samlIpSos,
              'samlSpAcs': this.ssoDetails.samlSpAcs,
              'samlSpId': this.ssoDetails.samlSpId,
              'samlSpSls': this.ssoDetails.samlSpSls,
              'samlIpEmailAttr': this.ssoDetails.samlIpEmailAttr,
              'samlIpFirstAttr': this.ssoDetails.samlIpFirstAttr,
              'samlIpLastAttr': this.ssoDetails.samlIpLastAttr,
              'samlIpCfr': 'cfr',
              'samlSigAlg': this.ssoDetails.samlSigAlg,
              'samlIpCert': fileContent,
              'ldapEnabled': this.ssoDetails.ldapEnabled,
              'ldapLoginEnabled': this.ssoDetails.ldapLoginEnabled,
              'ldapServer': this.ssoDetails.ldapServer,
              'ldapPort': this.ssoDetails.ldapPort,
              'ldapUsername': this.ssoDetails.ldapUsername,
              'ldapPassword': this.ssoDetails.ldapPassword,
              'ldapBaseDn': this.ssoDetails.ldapBaseDn,
              'ldapIdentifier': this.ssoDetails.ldapIdentifier,
              'ldapUsersCn': this.ssoDetails.ldapUsersCn,
              'ldapGroupsCn': this.ssoDetails.ldapGroupsCn,
              'ldapTls': this.ssoDetails.ldapTls
            };

            this.$store.dispatch('saveSsoDetails', payload).then( () => {
              this.updateLog('Admin', 'Updated', 'SSO details updated.');
              this.snackSave();
            });
          })();
        }else {
          payload = {
            'msalEnabled': this.ssoDetails.msalEnabled,
            'msalClientId': this.ssoDetails.msalClientId,
            'msalAuthority': this.ssoDetails.msalAuthority,
            'msalRedirectUri': this.ssoDetails.msalRedirectUri,
            'msalAuthState': this.ssoDetails.msalAuthState,
            'samlEnabled': this.ssoDetails.samlEnabled,
            'samlIpId': this.ssoDetails.samlIpId,
            'samlIpSls': this.ssoDetails.samlIpSls,
            'samlIpSos': this.ssoDetails.samlIpSos,
            'samlSpAcs': this.ssoDetails.samlSpAcs,
            'samlSpId': this.ssoDetails.samlSpId,
            'samlSpSls': this.ssoDetails.samlSpSls,
            'samlIpEmailAttr': this.ssoDetails.samlIpEmailAttr,
            'samlIpFirstAttr': this.ssoDetails.samlIpFirstAttr,
            'samlIpLastAttr': this.ssoDetails.samlIpLastAttr,
            'samlIpCfr': 'cfr',
            'samlSigAlg': this.ssoDetails.samlSigAlg,
            'samlIpCert': fileContent,
            'ldapEnabled': this.ssoDetails.ldapEnabled,
            'ldapLoginEnabled': this.ssoDetails.ldapLoginEnabled,
            'ldapServer': this.ssoDetails.ldapServer,
            'ldapPort': this.ssoDetails.ldapPort,
            'ldapUsername': this.ssoDetails.ldapUsername,
            'ldapPassword': this.ssoDetails.ldapPassword,
            'ldapBaseDn': this.ssoDetails.ldapBaseDn,
            'ldapIdentifier': this.ssoDetails.ldapIdentifier,
            'ldapUsersCn': this.ssoDetails.ldapUsersCn,
            'ldapGroupsCn': this.ssoDetails.ldapGroupsCn,
            'ldapTls': this.ssoDetails.ldapTls
          };

          this.$store.dispatch('saveSsoDetails', payload).then( () => {
            this.updateLog('Admin', 'Updated', 'SSO details updated.');
            this.snackSave();
          });
        }

        // Save Auto Sync details
        let autoPayload = {
          'ldapAutoSync': this.ldapAutoSync,
          'ldapAutoSyncTime': this.ldapAutoSyncTime,
        };
        this.$store.dispatch('saveAutoSyncDetails', autoPayload);
      },
      async ldapSelect(type) {
        if(type == 'groups') {
          this.loadingLdapGroups = true;
        }else {
          this.loadingLdapUsers = true;
        }

        await this.$store.dispatch('ldapSelect').then( () => {
          if(this.ldapSelectStatus) {
            this.$store.dispatch('getCurrentLdapSelection', type);
          }
        });
      },
      showLdapSelect(type) {
        if(type == 'groups') {
          this.loadingLdapGroups = false;
          this.ldapSelectGroupsDialog = true;
        }else {
          this.loadingLdapUsers = false;
          this.ldapSelectUsersDialog = true;
        }
      },
      confirmLdapSelectGroups(items) {
        let ldapUsers = [];
        let ldapGroups = [];
        let ldapGroupsToRemove = [];
        let removeFromGroup = [];

        // Get selected group data
        let selectedData = [];

        const findItemNested = (arr, itemId, nestingKey) => (
          arr.reduce((a, item) => {
            if (a) return a;
            if (item.id === itemId) return item;
            if (item[nestingKey]) return findItemNested(item[nestingKey], itemId, nestingKey)
          }, null)
        );
        
        if(items.availableLdapGroupsSelected) {
          for(let i = 0; i < items.availableLdapGroupsSelected.length; i++) {
            let groupItem = findItemNested(this.availableLdapTree, items.availableLdapGroupsSelected[i], "children");
            selectedData.push(groupItem.data);

            ldapGroups.push({ cn: groupItem.data.cn, dn: groupItem.data.distinguishedName, guid: groupItem.data.objectGUID, 
              acc: groupItem.data.sAMAccountName, member: groupItem.data.member, groupUsers: groupItem.data.groupUsers });

            // If group already sync'ed, compare groupUsers against existing ones
            if(this.ldapSelectedData.currentLdapGroupsSelected) {
              let previousSelection = this.ldapSelectedData.currentLdapGroupsSelected;

              // Loop through previous sync'ed groups data
              for(let j = 0; j < previousSelection.length; j++) {
                // Check if we are sync'ing an existing group
                if(previousSelection[j].objectGUID == groupItem.data.objectGUID) {
                  let previousGroupUsers = previousSelection[j].groupUsers;
                  let currentGroupUsers = groupItem.data.groupUsers;
                  let groupCn = previousSelection[j].cn;
                  // Loop through the existing group data and compare each user to the new group data
                  for(let k = 0; k < previousGroupUsers.length; k++) {
                    let removeUser = true;
                    for(let l = 0; l < currentGroupUsers.length; l++) {
                      // If we have a match, don't remove this user
                      if(previousGroupUsers[k].objectGUID == currentGroupUsers[l].objectGUID) {
                        removeUser = false;
                      }
                    }

                    if(removeUser) {
                      previousGroupUsers[k].groupCn = groupCn;
                      removeFromGroup.push(previousGroupUsers[k]);
                    }
                  }
                }
              }
            }
          }
        }
        
        if(this.ldapSelectedData.currentLdapGroupsSelected) {
          let previousSelection = this.ldapSelectedData.currentLdapGroupsSelected;

          for(let j = 0; j < previousSelection.length; j++) {
            if(!selectedData) {
              // No groups are selected, so remove all existing ones
              ldapGroupsToRemove.push(previousSelection[j]);
            }else {
              let removeGroup = true;

              for(let k = 0; k < selectedData.length; k++) {
                if(previousSelection[j].objectGUID == selectedData[k].objectGUID) {
                  removeGroup = false;
                }
              }

              if(removeGroup) {
                ldapGroupsToRemove.push(previousSelection[j]);
              }
            }
          }
          
        }

        let payload = {
          'ldapUsers': JSON.stringify(ldapUsers),
          'ldapGroups': JSON.stringify(ldapGroups),
          'type': 'groups'
        };

        this.$store.dispatch('saveLdapItems', payload).then( () => {
          this.ldapSelectGroupsDialog = false;
          this.availableLdapGroupsSelected = [];
          selectedData = [];

          // Remove these users from the group
          if(removeFromGroup.length > 0) {
            this.$store.dispatch('removeLdapUserFromGroup', removeFromGroup);
          }

          // Remove these groups
          if(ldapGroupsToRemove.length > 0) {
            this.$store.dispatch('removeLdapGroups', ldapGroupsToRemove);
          }

          // Sync groups
          if(ldapGroups.length > 0) {
            this.ldapSync('groups');
          }
        });
      },
      confirmLdapSelectUsers(items) {
        let ldapUsers = [];
        let ldapGroups = [];
        let ldapUsersToRemove = [];
        
        if(items.availableLdapUsersSelected) {
          for(let i = 0; i < items.availableLdapUsersSelected.length; i++) {
            ldapUsers.push({ cn: items.availableLdapUsersSelected[i].cn, dn: items.availableLdapUsersSelected[i].distinguishedName, 
              guid: items.availableLdapUsersSelected[i].objectGUID, mail: items.availableLdapUsersSelected[i].mail, 
              username: items.availableLdapUsersSelected[i].sAMAccountName, memberOf: items.availableLdapUsersSelected[i].memberOf, 
              givenName: items.availableLdapUsersSelected[i].givenName, sn: items.availableLdapUsersSelected[i].sn });
          }
        }

        if(this.ldapSelectedData.currentLdapUsersSelected) {
          let previousSelection = this.ldapSelectedData.currentLdapUsersSelected;

          for(let j = 0; j < previousSelection.length; j++) {
            if(!items.availableLdapUsersSelected) {
              // No users are selected, so remove all existing ones
              ldapUsersToRemove.push(previousSelection[j]);
            }else {
              let removeUser = true;

              for(let k = 0; k < items.availableLdapUsersSelected.length; k++) {
                if(previousSelection[j].objectGUID == items.availableLdapUsersSelected[k].objectGUID) {
                  removeUser = false;
                }
              }

              if(removeUser) {
                // Check is user is an admin
                for(let k = 0; k < this.allUsers.length; k++) {
                  if(previousSelection[j].sAMAccountName == this.allUsers[k].id) {
                    // If not, mark for removal
                    if(this.allUsers[k].role != 'adminRole') {
                      ldapUsersToRemove.push(previousSelection[j]);
                    }
                  }
                }
              }
            }
          }
        }

        let payload = {
          'ldapUsers': JSON.stringify(ldapUsers),
          'ldapGroups': JSON.stringify(ldapGroups),
          'type': 'users'
        };

        this.$store.dispatch('saveLdapItems', payload).then( () => {
          this.ldapSelectUsersDialog = false;
          this.availableLdapUsersSelected = [];

          // Remove these users
          if(ldapUsersToRemove.length > 0) {
            this.$store.dispatch('removeLdapUsers', ldapUsersToRemove);
          }

          // Sync users
          if(ldapUsers.length > 0) {
            this.ldapSync('users');
          }
        });
      },
      cancelLdapSelect() {
        this.ldapSelectGroupsDialog = false;
        this.ldapSelectUsersDialog = false;
        this.availableLdapUsersSelected = [];
        this.availableLdapGroupsSelected = [];
      },
      ldapSync(type) {
        this.ldapSyncingDialog = true;
        if(type == 'groups') {
          this.$store.dispatch('ldapSyncGroups').then( () => {
            // Do something
            this.ldapSyncingDialog = false;
          });
        }else {
          this.$store.dispatch('ldapSyncUsers').then( () => {
            // Do something
            this.ldapSyncingDialog = false;
          });
        }
      },
      refreshUsers () {
        this.loadingUsers = true;
        this.$store.dispatch('getAllUsers').then( () => {
          // Apply sort field and order
          let field = this.$store.state.adminUsersSortField;
          let sort = this.$store.state.adminUsersSortOrder;
          
          if(field == null) {
            this.usersSortBy = 'lastName';
            this.usersSortDesc = false;
          }else if (sort == 'none') {
            this.usersSortBy = '';
            this.usersSortDesc = false;
          }else {
            this.usersSortBy = field;

            if(sort == 'descending') {
              this.usersSortDesc = true;
            }else {
              this.usersSortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.userHeaders.length; i++) {
              if(column == ref.userHeaders[i].text) {
                ref.$store.commit('setAdminUsersSortField', ref.userHeaders[i].value);
                ref.$store.commit('setAdminUsersSortOrder', order);
              }
            }
          });
          this.loadingUsers = false;
        });
      },
      refreshGroups () {
        this.loadingGroups = false;
        this.$store.dispatch('getAllGroups').then( () => {
          // Apply sort field and order
          let field = this.$store.state.adminGroupsSortField;
          let sort = this.$store.state.adminGroupsSortOrder;
          if(field == null) {
            this.groupsSortBy = 'name';
            this.groupsSortDesc = false;
          }else if (sort == 'none') {
            this.groupsSortBy = '';
            this.groupsSortDesc = false;
          }else {
            this.groupsSortBy = field;

            if(sort == 'descending') {
              this.groupsSortDesc = true;
            }else {
              this.groupsSortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let j = 0; j < ref.groupHeaders.length; j++) {
              if(column == ref.groupHeaders[j].text) {
                ref.$store.commit('setAdminGroupsSortField', ref.groupHeaders[j].value);
                ref.$store.commit('setAdminGroupsSortOrder', order);
              }
            }
          });
          this.loadingGroups = false;
        });
      },
      refreshConnections () {
        this.loadingExts = true;
        this.$store.dispatch('getAllConnections').then( () => {
          // Add title for table view
          for(let c = 0; c < this.allExtDbs.length; c++) {
            if(this.allExtDbs[c].CONN_TYPE == 'mysql') {
              this.allExtDbs[c]['CONN_TYPE_TITLE'] = 'MySQL';
            }
            if(this.allExtDbs[c].CONN_TYPE == 'postgresql') {
              this.allExtDbs[c]['CONN_TYPE_TITLE'] = 'Postgres';
            }
            if(this.allExtDbs[c].CONN_TYPE == 'sqlserver') {
              this.allExtDbs[c]['CONN_TYPE_TITLE'] = 'Azure (MSSQL)';
            }
            if(this.allExtDbs[c].CONN_TYPE == 'mssql') {
              this.allExtDbs[c]['CONN_TYPE_TITLE'] = 'MSSQL';
            }
            if(this.allExtDbs[c].CONN_TYPE == 'oracle') {
              this.allExtDbs[c]['CONN_TYPE_TITLE'] = 'Oracle';
            }
          }

          // Apply sort field and order
          let field = this.$store.state.adminExtDbSortField;
          let sort = this.$store.state.adminExtDbSortOrder;
          if(field == null) {
            this.extDbSortBy = 'ID';
            this.extDbSortDesc = true;
          }else if (sort == 'none') {
            this.extDbSortBy = '';
            this.extDbSortDesc = false;
          }else {
            this.extDbSortBy = field;

            if(sort == 'descending') {
              this.extDbSortDesc = true;
            }else {
              this.extDbSortDesc = false;
            }
          }

          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let closest = $(this).closest('.v-data-table');
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            if(closest.hasClass('ext-list')) {
              for(let i = 0; i < ref.extDbHeaders.length; i++) {
                if(column == ref.extDbHeaders[i].text) {
                  ref.$store.commit('setAdminExtDbSortField', ref.extDbHeaders[i].value);
                  ref.$store.commit('setAdminExtDbSortOrder', order);
                }
              }
            }
            // Use the same click event for Harlequin Connections
            if(closest.hasClass('conn-list')) {
              for(let i = 0; i < ref.hqConnHeaders.length; i++) {
                if(column == ref.hqConnHeaders[i].text) {
                  ref.$store.commit('setAdminHqConnSortField', ref.hqConnHeaders[i].value);
                  ref.$store.commit('setAdminHqConnSortOrder', order);
                }
              }
            }
          });
          this.loadingExts = false;
        });
      },
      refreshHqConnections () {
        this.loadingConns = true;
        this.$store.dispatch('getAllHqConnections').then( () => {
          // Apply sort field and order
          let field = this.$store.state.adminHqConnSortField;
          let sort = this.$store.state.adminHqConnSortOrder;
          if(field == null) {
            this.hqConnSortBy = 'ID';
            this.hqConnSortDesc = true;
          }else if (sort == 'none') {
            this.hqConnSortBy = '';
            this.hqConnSortDesc = false;
          }else {
            this.hqConnSortBy = field;

            if(sort == 'descending') {
              this.hqConnSortDesc = true;
            }else {
              this.hqConnSortDesc = false;
            }
          }

          // Remove previous click events
          // $('.text-start.sortable').off();
          // // Add new click events for storing order
          // let ref = this;
          // $('.text-start.sortable').click(function() {
          //   let column = $(this)[0].firstChild.innerHTML;
          //   let order = $(this).attr('aria-sort');
            
          //   for(let i = 0; i < ref.hqConnHeaders.length; i++) {
          //     if(column == ref.hqConnHeaders[i].text) {
          //       ref.$store.commit('setAdminHqConnSortField', ref.hqConnHeaders[i].value);
          //       ref.$store.commit('setAdminHqConnSortOrder', order);
          //     }
          //   }
          // });
          this.loadingConns = false;
        });
      },
      refreshRemoteTenants() {
        this.$store.dispatch('refreshRemoteTenants');
      },
      refreshApis () {
        this.loadingApis = true;
        this.$store.dispatch('getAllApis').then( () => {
          // Apply sort field and order
          let field = this.$store.state.adminApiSortField;
          let sort = this.$store.state.adminApiSortOrder;
          if(field == null) {
            this.apisSortBy = 'FRIENDLY_NAME';
            this.apisSortDesc = false;
          }else if (sort == 'none') {
            this.apisSortBy = '';
            this.apisSortDesc = false;
          }else {
            this.apisSortBy = field;

            if(sort == 'descending') {
              this.apisSortDesc = true;
            }else {
              this.apisSortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.apiHeadings.length; i++) {
              if(column == ref.apiHeadings[i].text) {
                ref.$store.commit('setAdminApiSortField', ref.apiHeadings[i].value);
                ref.$store.commit('setAdminApiSortOrder', order);
              }
            }
          });
          this.loadingApis = false;
        });
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      refreshOpLog() {
        if(this.dateTo == '') {
          let dt = new Date()
          this.dateTo = dt.toISOString().split('T')[0]
        }
        if(this.dateFrom == '') {
          let current = new Date(this.dateTo);
          let target = current.setMonth(current.getMonth() - 1);
          let df = new Date(target);
          this.dateFrom = df.toISOString().split('T')[0]
        }
        let payload = {
          'dateFrom': this.dateFrom,
          'dateTo': this.dateTo
        }

        this.loadingOps = true;
        this.$store.dispatch('getOpLog', payload).then( () => {
          // Add title for table view
          for(let o = 0; o < this.operationLog.length; o++) {
            if(this.operationLog[o].CASE_ID == 0) {
              this.operationLog[o].CASE_ID = '';
            }
          }

          // Apply sort field and order
          let field = this.$store.state.adminOpLogSortField;
          let sort = this.$store.state.adminOpLogSortOrder;
          if(field == null) {
            this.opLogSortBy = 'ID';
            this.opLogSortDesc = true;
          }else if (sort == 'none') {
            this.opLogSortBy = '';
            this.opLogSortDesc = false;
          }else {
            this.opLogSortBy = field;

            if(sort == 'descending') {
              this.opLogSortDesc = true;
            }else {
              this.opLogSortDesc = false;
            }
          }

          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.opLogHeaders.length; i++) {
              if(column == ref.opLogHeaders[i].text) {
                ref.$store.commit('setAdminOpLogSortField', ref.opLogHeaders[i].value);
                ref.$store.commit('setAdminOpLogSortOrder', order);
              }
            }
          });
          this.loadingOps = false;
        });
      },
      refreshErrorLog() {
        this.loadingErrors = true;
        this.$store.dispatch('getErrorLog', 'get').then( () => {

          // Apply sort field and order
          // let field = this.$store.state.adminOpLogSortField;
          // let sort = this.$store.state.adminOpLogSortOrder;
          // if(field == null) {
          //   this.opLogSortBy = 'ID';
          //   this.opLogSortDesc = true;
          // }else if (sort == 'none') {
          //   this.opLogSortBy = '';
          //   this.opLogSortDesc = false;
          // }else {
          //   this.opLogSortBy = field;

          //   if(sort == 'descending') {
          //     this.opLogSortDesc = true;
          //   }else {
          //     this.opLogSortDesc = false;
          //   }
          // }

          // // Remove previous click events
          // $('.text-start.sortable').off();
          // // Add new click events for storing order
          // let ref = this;
          // $('.text-start.sortable').click(function() {
          //   let column = $(this)[0].firstChild.innerHTML;
          //   let order = $(this).attr('aria-sort');
            
          //   for(let i = 0; i < ref.errorLogHeaders.length; i++) {
          //     if(column == ref.errorLogHeaders[i].text) {
          //       ref.$store.commit('setAdminOpLogSortField', ref.opLogHeaders[i].value);
          //       ref.$store.commit('setAdminOpLogSortOrder', order);
          //     }
          //   }
          // });
          this.loadingErrors = false;
        });
      },
      clearErrorLog() {
        this.$store.dispatch('getErrorLog', 'clear').then( () => {
          this.snackErrorLogCleared();
        });
      },
      remoteUserTenantCheck(userId) {
        let tenants = [];

        for(let i = 0; i < this.allHqConns.length; i++) {
          for(let j = 0; j < this.tenantInfo.length; j++) {
            if(this.allHqConns[i].ID == this.tenantInfo[j].engineId) {
              tenants.push({ 'engineUrl': this.allHqConns[i].URL, 'tenantId': this.tenantInfo[j].tenantId, 'id': this.tenantInfo[j].id, 'engineId': this.tenantInfo[j].engineId, 'tenantName': this.tenantInfo[j].tenantName });
            }
          }
        }

        let payload = {
          'userId': userId,
          'tenants': tenants
        };
        this.$store.dispatch('remoteUserTenantCheck', payload);
      },
      remoteGroupTenantCheck(groupId) {
        let tenants = [];

        for(let i = 0; i < this.allHqConns.length; i++) {
          for(let j = 0; j < this.tenantInfo.length; j++) {
            if(this.allHqConns[i].ID == this.tenantInfo[j].engineId) {
              tenants.push({ 'engineUrl': this.allHqConns[i].URL, 'tenantId': this.tenantInfo[j].tenantId, 'id': this.tenantInfo[j].id, 'engineId': this.tenantInfo[j].engineId, 'tenantName': this.tenantInfo[j].tenantName });
            }
          }
        }

        let payload = {
          'groupId': groupId,
          'tenants': tenants
        };
        this.$store.dispatch('remoteGroupTenantCheck', payload);
      },
      editUser(item) {
        this.remoteUserTenantCheck(item.id);
        this.editUserTitle = this.$t('ADMIN.USERS.EDIT_USER.TITLE') + ' ' + item.firstName + ' ' + item.lastName;
        this.editUserText = this.$t('ADMIN.USERS.EDIT_USER.DESC') 
        this.passwordPolicy = this.$t('ADMIN.USERS.PASS_POLICY') 
        this.userId = item.id;
        this.email = item.email;
        this.firstName = item.firstName;
        this.lastName = item.lastName;
        this.role = item.role;
        this.currentRole = item.role;
        this.userAction = 'edit';
      },
      showEditDialog() {
        for(let i = 0; i < this.remoteUserTenants.length; i++) {
          for(let j = 0; j < this.tenantInfo.length; j++) {
            if(this.remoteUserTenants[i].id == this.tenantInfo[j].id) {
              this.tenantSelected.push(this.tenantInfo[j].id);
              this.existingTenants.push(this.tenantInfo[j].id);
            }
          }
        }

        this.editUserDialog = true;
      },
      async confirmEditUser(item) {
        this.editUserDialog = false;
        let credPayload = {};
        let roleData = {};
        let decipher = '';
        
        let payload = {
          'id': item.userId,
          'firstName': item.firstName,
          'lastName': item.lastName,
          'email': item.email
        };
        await this.$store.dispatch('editUser', payload).then( async () => {
          this.updateLog('Admin', 'Updated', 'User details updated for ' + item.userId + '.');

          if(item.password1 != '') {
            decipher = cryptojs.AES.decrypt(this.$store.state.xAuthToken, this.$store.state.randomKey);
            credPayload = {
              'userId': item.userId,
              'credData': {
                'password': item.password1,
                'authenticatedUserPassword': decipher.toString(cryptojs.enc.Utf8)
              }
            };
            await this.$store.dispatch('updateUserCreds', credPayload).then( () => {
              this.updateLog('Admin', 'Updated', 'User credentials updated for ' + item.userId + '.');
            });
          }
          if(item.role != this.currentRole) {
            roleData = {
              'removeRole': {
                'id': this.currentRole,
                'userId': item.userId
              },
              'addRole': {
                'id': item.role,
                'userId': item.userId
              }
            };
            await this.$store.dispatch('updateUserRole', roleData).then(async () => {
              this.updateLog('Admin', 'Updated', 'User role updated for ' + item.userId + ' from ' + this.currentRole + ' to ' + item.role + '.');

              this.userId = '';
              this.email = '';
              this.firstName = '';
              this.lastName = '';
              this.role = null;
              this.password1 = '';
              this.password2 = '';
              this.$refs.editUserForm.resetValidation();
              this.userAction = '';
              this.refreshUsers();
            });
          }else {
            this.userId = '';
            this.email = '';
            this.firstName = '';
            this.lastName = '';
            this.role = null;
            this.password1 = '';
            this.password2 = '';
            this.$refs.editUserForm.resetValidation();
            this.refreshUsers();
          }
        });

        if(this.updateAllInstances) {
          for(let i = 0; i < this.remoteUserTenants.length; i++) {
            let engineUrl = '';
            let engineName = '';
            let tenantName = '';

            for(let j = 0; j < this.allHqConns.length; j++) {
              if(this.remoteUserTenants[i].engineId == this.allHqConns[j].ID) {
                engineUrl = this.allHqConns[j].URL;
                engineName = this.allHqConns[j].ENGINE_NAME;
                tenantName = this.remoteUserTenants[i].tenantName;
                break;
              }
            }

            let userPayload = {
              'engineUrl': engineUrl,
              'userPayload': payload
            };

            await this.$store.dispatch('remoteEditUser', userPayload).then( async () => {
              this.updateLog('Admin', 'Updated', 'User details updated for ' + item.userId + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
              this.snackRemoteUserOk('User details successfully updated for ' + item.userId + ' on engine ' + engineName + '.');

              if(item.password1 != '') {
                decipher = cryptojs.AES.decrypt(this.$store.state.extAuthToken, this.$store.state.randomKey);
                credPayload = {
                  'engineUrl': engineUrl,
                  'userId': item.userId,
                  'credData': {
                    'password': item.password1,
                    'authenticatedUserPassword': decipher.toString(cryptojs.enc.Utf8)
                  }
                };
                await this.$store.dispatch('remoteUpdateUserCreds', credPayload).then( () => {
                  this.updateLog('Admin', 'Updated', 'User credentials updated for ' + item.userId + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
                  this.snackRemoteUserOk('User credentials successfully updated for ' + item.userId + ' on engine ' + engineName + '.');
                });
              }
              if(item.role != this.currentRole) {
                roleData = {
                  'engineUrl': engineUrl,
                  'removeRole': {
                    'id': this.currentRole,
                    'userId': item.userId
                  },
                  'addRole': {
                    'id': item.role,
                    'userId': item.userId
                  }
                };
                await this.$store.dispatch('remoteUpdateUserRole', roleData).then(async () => {
                  this.updateLog('Admin', 'Updated', 'User role updated for ' + item.userId + ' from ' + this.currentRole + ' to ' + item.role + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
                  this.snackRemoteUserOk('User role successfully updated for ' + item.userId + ' on engine ' + engineName + '.');
                });
              }
            });
          }

          this.currentRole = null;
          this.updateAllInstances = null;
        }

        // Add user remotely to other tenants
        if(this.tenantSelected.length > 0) {
          let addToTenant = [];
          for(let i = 0; i < this.tenantSelected.length; i++) {
            addToTenant.push(this.tenantSelected[i]);
            for(let j = 0; j < this.existingTenants.length; j++) {
              if(addToTenant[i] == this.existingTenants[j]) {
                addToTenant.splice(i, 1);
              }
            }

          }

          if(addToTenant.length > 0) {
            let userPayload = {
              'profile': {
                'id': item.userId,
                'firstName': item.firstName,
                'lastName': item.lastName,
                'email': item.email
              }
            };

            let rolePayload = {
              'id': item.role,
              'userId': item.userId
            };

            this.addRemoteUserPayload = {
              'userPayload': userPayload,
              'tenantSelected': addToTenant,
              'tenantInfo': this.tenantInfo,
              'allHqConns': this.allHqConns,
              'rolePayload': rolePayload
            };
            
            this.addRemoteUser(addToTenant, item);
          }
        }

        // Delete user remotely from other tenants
        if(this.existingTenants.length > 0) {
          let removeTenant = true;
          let removeFromTenant = [];
          for(let i = 0; i < this.existingTenants.length; i++) {
            for(let j = 0; j < this.tenantSelected.length; j++) {
              if(this.existingTenants[i] == this.tenantSelected[j]) {
                removeTenant = false;
              }
            }

            if(removeTenant) {
              removeFromTenant.push(this.existingTenants[i]);
            }
          }

          if(removeFromTenant.length > 0) {
            this.removeRemoteUser(removeFromTenant, item.userId);
          }
        }

        this.tenantSelected = [];
        this.existingTenants = [];        
      },
      cancelEditUser() {
        this.editUserDialog = false;
        this.userId = '';
        this.email = '';
        this.firstName = '';
        this.lastName = '';
        this.role = null;
        this.currentRole = null;
        this.password1 = '';
        this.password2 = '';
        this.$refs.editUserForm.resetValidation();
        this.tenantSelected = [];
        this.existingTenants = [];
        this.userAction = '';
      },
      addRemoteUser(tenants, item) {
        if(item.password1 != '') {
          this.confirmAddRemoteUser(item);
        }else {
          this.addRemoteUserTitle = this.$t('ADMIN.USERS.ADD_USER.REMOTE.TITLE') + ' ' + item.userId;
          this.addRemoteUserText = '<p>' + this.$t('ADMIN.USERS.ADD_USER.REMOTE.DESC_1') + '</p>';

          for(let i = 0; i < tenants.length; i++) {
            for(let j = 0; j < this.tenantInfo.length; j++) {
              if(tenants[i] == this.tenantInfo[j].id) {
                for(let k = 0; k < this.allHqConns.length; k++) {
                  if(this.tenantInfo[j].engineId == this.allHqConns[k].ID) {
                    this.addRemoteUserText += '<p>' + this.allHqConns[k].ENGINE_NAME + '</p>';
                  }
                }
              }
            }
          }

          this.addRemoteUserText += '<p>' + this.$t('ADMIN.USERS.ADD_USER.REMOTE.DESC_2') + '</p>';
          this.addRemoteUserDialog = true;
        }
      },
      confirmAddRemoteUser(item) {
        this.addRemoteUserDialog = false;

        this.addRemoteUserPayload.userPayload['credentials'] = { 'password': item.password1 };

        this.$store.dispatch('remoteAddUser', this.addRemoteUserPayload);

        this.password1 = '';
        this.password2 = '';
        this.$refs.addRemoteUserForm.resetValidation();
      },
      cancelAddRemoteUser() {
        this.addRemoteUserDialog = false;
        this.$refs.addRemoteUserForm.resetValidation();
      },
      removeRemoteUser(tenants, userId) {
        this.removeRemoteUserTitle = this.$t('ADMIN.USERS.DELETE_USER.REMOTE.TITLE') + ' ' + userId;
        this.removeRemoteUserText = '<p>' + this.$t('ADMIN.USERS.DELETE_USER.REMOTE.DESC_1') + '</p>';

        for(let i = 0; i < tenants.length; i++) {
          for(let j = 0; j < this.tenantInfo.length; j++) {
            if(tenants[i] == this.tenantInfo[j].id) {
              for(let k = 0; k < this.allHqConns.length; k++) {
                if(this.tenantInfo[j].engineId == this.allHqConns[k].ID) {
                  this.removeRemoteUserText += '<p>' + this.allHqConns[k].ENGINE_NAME + '</p>';
                }
              }
            }
          }
        }

        this.removeRemoteUserText += '<p>' + this.$t('ADMIN.USERS.DELETE_USER.REMOTE.DESC_2') + '</p>';
        this.removeRemoteUserId = userId;
        this.removeFromTenant = tenants;
        this.removeRemoteUserDialog = true;
      },
      confirmRemoveRemoteUser() {
        this.removeRemoteUserDialog = false;

        let enginePayload = {};
        let engineName = '';
        let tenantName = '';
        for(let k = 0; k < this.removeFromTenant.length; k++) {
          let selectedId = this.removeFromTenant[k];

          for(let l = 0; l < this.tenantInfo.length; l++) {
            if(selectedId == this.tenantInfo[l].id) {
              let engineId = this.tenantInfo[l].engineId;
              let tenantId = this.tenantInfo[l].tenantId;
              tenantName = this.tenantInfo[l].tenantName;

              for(let m = 0; m < this.allHqConns.length; m++) {
                if(engineId == this.allHqConns[m].ID) {
                  let engineUrl = this.allHqConns[m].URL;
                  engineName = this.allHqConns[m].ENGINE_NAME;

                  enginePayload = { 
                    'tenantId': tenantId, 
                    'engineUrl': engineUrl
                  };

                  break;
                }
              }
            }
          }

          let payload = {
            'enginePayload': enginePayload,
            'userId': this.removeRemoteUserId
          }
          
          this.$store.dispatch('remoteDeleteUser', payload).then( () => {
            this.updateLog('Admin', 'Deleted', 'User ' + this.removeRemoteUserId + ' deleted remotely on engine ' + engineName + ', tenant ' + tenantName + '.');
            this.snackRemoteUserOk('User ' + this.removeRemoteUserId + ' successfully deleted on engine ' + engineName + '.');
          });
        }
      },
      deleteUser(item) {
        this.remoteUserTenantCheck(item.id);
        this.deleteUserTitle = this.$t('ADMIN.USERS.DELETE_USER.TITLE');
        this.deleteUserText = this.$t('ADMIN.USERS.DELETE_USER.DESC') + ': ' + item.firstName + ' ' + item.lastName;
        this.userId = item.id;
        this.userAction = 'delete';
      },
      showDeleteDialog() {
        this.deleteUserDialog = true;
      },
      confirmDeleteUser(item) {
        this.deleteUserDialog = false;
        this.$store.dispatch('deleteUser', item.userId).then( () => {
          this.updateLog('Admin', 'Deleted', 'User ' + item.userId + ' deleted.');

          this.userId = '';
          this.userAction = '';
          this.refreshUsers();
        });

        // Delete user remotely
        if(this.tenantSelected.length > 0) {
          let enginePayload = {};
          let engineName = '';
          let tenantName = '';
          for(let j = 0; j < this.tenantSelected.length; j++) {
            let selectedId = this.tenantSelected[j];

            for(let k = 0; k < this.tenantInfo.length; k++) {
              if(selectedId == this.tenantInfo[k].id) {
                let engineId = this.tenantInfo[k].engineId;
                let tenantId = this.tenantInfo[k].tenantId;
                tenantName = this.tenantInfo[k].tenantName;

                for(let l = 0; l < this.allHqConns.length; l++) {
                  if(engineId == this.allHqConns[l].ID) {
                    let engineUrl = this.allHqConns[l].URL;
                    engineName = this.allHqConns[l].ENGINE_NAME;

                    enginePayload = { 
                      'tenantId': tenantId, 
                      'engineUrl': engineUrl
                    };

                    break;
                  }
                }
              }
            }

            let payload = {
              'enginePayload': enginePayload,
              'userId': item.userId
            }

            this.$store.dispatch('remoteDeleteUser', payload).then( () => {
              this.updateLog('Admin', 'Deleted', 'User ' + item.userId + ' deleted remotely on engine ' + engineName + ', tenant ' + tenantName + '.');
              this.snackRemoteUserOk('User ' + item.userId + ' successfully deleted on engine ' + engineName + '.');
            });
          }
          this.tenantSelected = [];
        }
      },
      editGroup(item) {
        this.remoteGroupTenantCheck(item.id);
        this.editGroupTitle = this.$t('ADMIN.GROUPS.EDIT_GROUP.TITLE') + ' ' + item.name;
        this.editGroupText = this.$t('ADMIN.GROUPS.EDIT_GROUP.DESC');
        this.groupId = item.id;
        this.groupName = item.name;
        this.groupAction = 'edit';
      },
      showEditGroupDialog() {
        for(let i = 0; i < this.remoteGroupTenants.length; i++) {
          for(let j = 0; j < this.tenantInfo.length; j++) {
            if(this.remoteGroupTenants[i].id == this.tenantInfo[j].id) {
              this.tenantSelected.push(this.tenantInfo[j].id);
              this.existingTenants.push(this.tenantInfo[j].id);
            }
          }
        }

        this.editGroupDialog = true;
      },
      async confirmEditGroup(item) {
        this.editGroupDialog = false;
        
        let payload = {
          'id': item.groupId,
          'name': item.groupName,
          'type': 'Workflow'
        };
        this.$store.dispatch('updateGroup', payload).then( () => {
          this.updateLog('Admin', 'Updated', 'Group ' + item.groupId + ' updated.');

          this.groupId = '';
          this.groupName = '';
          this.refreshGroups();
        });

        // Update group remotely
        if(this.updateAllInstances) {
          for(let i = 0; i < this.remoteGroupTenants.length; i++) {
            let engineUrl = '';
            let engineName = '';
            let tenantName = '';

            for(let j = 0; j < this.allHqConns.length; j++) {
              if(this.remoteGroupTenants[i].engineId == this.allHqConns[j].ID) {
                engineUrl = this.allHqConns[j].URL;
                engineName = this.allHqConns[j].ENGINE_NAME;
                tenantName = this.remoteGroupTenants[i].tenantName;
                break;
              }
            }

            let groupPayload = {
              'engineUrl': engineUrl,
              'groupPayload': payload
            };

            await this.$store.dispatch('remoteUpdateGroup', groupPayload).then( async () => {
              this.updateLog('Admin', 'Updated', 'Group details updated for ' + item.groupId + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
              this.snackRemoteUserOk('Group ' + item.groupId + ' successfully updated on engine ' + engineName + '.');
            });
          }

          this.updateAllInstances = null;
        }

        // Add group remotely to other tenants
        if(this.tenantSelected.length > 0) {
          let addToTenant = [];
          for(let k = 0; k < this.tenantSelected.length; k++) {
            addToTenant.push(this.tenantSelected[k]);
            for(let l = 0; l < this.existingTenants.length; l++) {
              if(addToTenant[k] == this.existingTenants[l]) {
                addToTenant.splice(k, 1);
              }
            }

          }

          if(addToTenant.length > 0) {
            let remoteGroupPayload = {
              'groupPayload': payload,
              'tenantSelected': addToTenant,
              'tenantInfo': this.tenantInfo,
              'allHqConns': this.allHqConns            };

            this.$store.dispatch('remoteAddGroup', remoteGroupPayload);
          }
        }

        // Delete group remotely from other tenants
        if(this.existingTenants.length > 0) {
          let removeTenant = true;
          let removeFromTenant = [];
          for(let m = 0; m < this.existingTenants.length; m++) {
            for(let n = 0; n < this.tenantSelected.length; n++) {
              if(this.existingTenants[m] == this.tenantSelected[n]) {
                removeTenant = false;
              }
            }

            if(removeTenant) {
              removeFromTenant.push(this.existingTenants[m]);
            }
          }

          if(removeFromTenant.length > 0) {
            let enginePayload = {};
            let engineName = '';
            let tenantName = '';
            for(let p = 0; p < removeFromTenant.length; p++) {
              let selectedId = removeFromTenant[p];

              for(let q = 0; q < this.tenantInfo.length; q++) {
                if(selectedId == this.tenantInfo[q].id) {
                  let engineId = this.tenantInfo[q].engineId;
                  let tenantId = this.tenantInfo[q].tenantId;
                  tenantName = this.tenantInfo[q].tenantName;

                  for(let r = 0; r < this.allHqConns.length; r++) {
                    if(engineId == this.allHqConns[r].ID) {
                      let engineUrl = this.allHqConns[r].URL;
                      engineName = this.allHqConns[r].ENGINE_NAME;

                      enginePayload = { 
                        'tenantId': tenantId, 
                        'engineUrl': engineUrl
                      };

                      break;
                    }
                  }
                }
              }

              let payload = {
                'enginePayload': enginePayload,
                'groupId': item.groupId
              }

              this.$store.dispatch('remoteDeleteGroup', payload).then( () => {
                this.updateLog('Admin', 'Deleted', 'Group ' + item.groupId + ' deleted remotely on engine ' + engineName + ', tenant ' + tenantName + '.');
                this.snackRemoteUserOk('Group ' + item.groupId + ' successfully deleted on engine ' + engineName + '.');
              });
            }
          }
        }

        this.tenantSelected = [];
        this.existingTenants = [];
      },
      cancelEditGroup() {
        this.editGroupDialog = false;
        this.groupId = '';
        this.groupName = '';
        this.tenantSelected = [];
        this.existingTenants = [];
        this.updateAllInstances = null;
      },
      deleteGroup(item) {
        this.remoteGroupTenantCheck(item.id);
        this.deleteGroupTitle = this.$t('ADMIN.GROUPS.DELETE_GROUP.TITLE');
        this.deleteGroupText = this.$t('ADMIN.GROUPS.DELETE_GROUP.DESC') + ': ' + item.name;
        this.groupId = item.id;
        this.groupAction = 'delete';
      },
      showDeleteGroupDialog() {
        this.deleteGroupDialog = true;
      },
      confirmDeleteGroup(item) {
        this.deleteGroupDialog = false;
        this.$store.dispatch('deleteGroup', item.groupId).then( () => {
          this.updateLog('Admin', 'Deleted', 'Group ' + item.groupId + ' deleted.');

          this.groupId = '';
          this.groupName = '';
          this.refreshGroups();
        });

        // Delete group remotely
        if(this.tenantSelected.length > 0) {
          let enginePayload = {};
          let engineName = '';
          let tenantName = '';
          for(let j = 0; j < this.tenantSelected.length; j++) {
            let selectedId = this.tenantSelected[j];

            for(let k = 0; k < this.tenantInfo.length; k++) {
              if(selectedId == this.tenantInfo[k].id) {
                let engineId = this.tenantInfo[k].engineId;
                let tenantId = this.tenantInfo[k].tenantId;
                tenantName = this.tenantInfo[k].tenantName;

                for(let l = 0; l < this.allHqConns.length; l++) {
                  if(engineId == this.allHqConns[l].ID) {
                    let engineUrl = this.allHqConns[l].URL;
                    engineName = this.allHqConns[l].ENGINE_NAME;

                    enginePayload = { 
                      'tenantId': tenantId, 
                      'engineUrl': engineUrl
                    };

                    break;
                  }
                }
              }
            }

            let payload = {
              'enginePayload': enginePayload,
              'groupId': item.groupId
            }

            this.$store.dispatch('remoteDeleteGroup', payload).then( () => {
              this.updateLog('Admin', 'Deleted', 'Group ' + item.groupId + ' deleted remotely on engine ' + engineName + ', tenant ' + tenantName + '.');
              this.snackRemoteUserOk('Group ' + item.groupId + ' successfully deleted on engine ' + engineName + '.');
            });
          }
          this.tenantSelected = [];
        }
      },
      async addRemoveUsers(item){
        this.groupAction = 'addRemove';
        this.remoteGroupTenantCheck(item.id);
        let payload = {
          'groupId': item.id,
          'callType': 'assignedTo'
        }
        await this.$store.dispatch('getUsersInGroup', payload).then(async () => {
          await this.$store.dispatch('getUnassignedUsers').then(async () => {
            this.addRemoveUsersTitle = this.$t('ADMIN.GROUPS.ADD_REMOVE_USERS.TITLE') + ' ' + item.name;
            this.addRemoveUsersText = this.$t('ADMIN.GROUPS.ADD_REMOVE_USERS.DESC');
            this.groupId = item.id;
            this.addRemoveUsersDialog = true;
          });
        });
      },
      addUsersToGroup(users) {
        let usersToAdd = [];
        for(let i =0; i < users.availableSelected.length; i++) {
          usersToAdd.push(users.availableSelected[i].id);
        }
        let payload = {
          'groupId': this.groupId,
          'users': usersToAdd
        }
        
        this.$store.dispatch('addUsersToGroup', payload).then( () => {
          this.updateLog('Admin', 'Added', 'Users ' + usersToAdd.toString() + ' added to group ' + this.groupId + '.');

          this.availableSelected = [];
          this.assignedSelected = [];
        });

        if(this.updateAllInstances) {
          for(let j = 0; j < this.remoteGroupTenants.length; j++) {
            let engineUrl = '';
            let engineName = '';
            let tenantName = '';

            for(let k = 0; k < this.allHqConns.length; k++) {
              if(this.remoteGroupTenants[j].engineId == this.allHqConns[k].ID) {
                engineUrl = this.allHqConns[k].URL;
                engineName = this.allHqConns[k].ENGINE_NAME;
                tenantName = this.remoteGroupTenants[j].tenantName;
                break;
              }
            }

            let payload = {
              'groupId': this.groupId,
              'users': usersToAdd,
              'engineUrl': engineUrl
            }
            
            this.$store.dispatch('remoteAddUsersToGroup', payload).then( () => {
              this.updateLog('Admin', 'Added', 'Users ' + usersToAdd.toString() + ' added remotely to group ' + this.groupId + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
              this.snackRemoteUserOk('Users successfully added to group ' + this.groupId + ' on engine ' + engineName + '.');
            });
          }

          this.updateAllInstances = null;
        }
      },
      removeUsersFromGroup(users) {
        let usersToRemove = [];
        for(let i =0; i < users.assignedSelected.length; i++) {
          usersToRemove.push(users.assignedSelected[i].id);
        }
        let payload = {
          'groupId': this.groupId,
          'users': usersToRemove
        }
        this.$store.dispatch('removeUsersFromGroup', payload).then( () => {
          this.updateLog('Admin', 'Removed', 'Users ' + usersToRemove.toString() + ' removed from group ' + this.groupId + '.');

          this.availableSelected = [];
          this.assignedSelected = [];
        });

        if(this.updateAllInstances) {
          for(let j = 0; j < this.remoteGroupTenants.length; j++) {
            let engineUrl = '';
            let engineName = '';
            let tenantName = '';

            for(let k = 0; k < this.allHqConns.length; k++) {
              if(this.remoteGroupTenants[j].engineId == this.allHqConns[k].ID) {
                engineUrl = this.allHqConns[k].URL;
                engineName = this.allHqConns[k].ENGINE_NAME;
                tenantName = this.remoteGroupTenants[j].tenantName;
                break;
              }
            }

            let payload = {
              'groupId': this.groupId,
              'users': usersToRemove,
              'engineUrl': engineUrl
            }
            
            this.$store.dispatch('remoteRemoveUsersFromGroup', payload).then( () => {
              this.updateLog('Admin', 'Removed', 'Users ' + usersToRemove.toString() + ' removed remotely from group ' + this.groupId + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
              this.snackRemoteUserOk('Users successfully removed from group ' + this.groupId + ' on engine ' + engineName + '.');
            });
          }

          this.updateAllInstances = null;
        }
      },
      cancelAddRemoveUsers() {
        this.addRemoveUsersDialog = false;
        this.groupId = '';
        this.groupName = '';
        this.availableSelected = [];
        this.assignedSelected = [];
        this.updateAllInstances = null;
      },
      addUser() {
        this.addUserTitle = this.$t('ADMIN.USERS.ADD_USER.TITLE');
        this.addUserText = this.$t('ADMIN.USERS.ADD_USER.DESC');
        this.passwordPolicy = this.$t('ADMIN.USERS.PASS_POLICY');
        this.addUserDialog = true;
      },
      confirmAddUser(item) {
        let exists = false;
        let payload = [];
        let rolePayload = [];

        for(let i = 0; i < this.allUsers.length; i++) {
          if(this.allUsers[i].id == item.userId) {
            exists = true;
            break;
          }
        }

        if(!exists) {
          this.addUserDialog = false;

          payload = {
            'profile': {
              'id': item.userId,
              'firstName': item.firstName,
              'lastName': item.lastName,
              'email': item.email
            },
            'credentials': {
              'password': item.password1
            }
          };
          this.$store.dispatch('addUser', payload).then( () => {
            this.updateLog('Admin', 'Created', 'User ' + item.userId + ' created.');

            rolePayload = {
              'id': item.role,
              'userId': item.userId
            };
            this.$store.dispatch('addUserToRole', rolePayload).then( () => {
              this.updateLog('Admin', 'Created', 'User ' + item.userId + ' added to role ' + item.role + '.');

              this.userId = '';
              this.email = '';
              this.firstName = '';
              this.lastName = '';
              this.password1 = '';
              this.password2 = '';
              this.role = null;
              this.$refs.addUserForm.resetValidation();
              this.refreshUsers();
            })
          

            // Add user remotely to other tenants
            if(this.tenantSelected.length > 0) {

              let remoteUserPayload = {
                'userPayload': payload,
                'tenantSelected': this.tenantSelected,
                'tenantInfo': this.tenantInfo,
                'allHqConns': this.allHqConns,
                'rolePayload': rolePayload
              };

              this.$store.dispatch('remoteAddUser', remoteUserPayload);
              this.tenantSelected = [];
            }
          });
        }else {
          let msg = 'A user with this username already exists. Please enter a different username.';
          this.snackExists(msg);
        }
      },
      cancelAddUser() {
        this.addUserDialog = false;
        this.userId = '';
        this.email = '';
        this.firstName = '';
        this.lastName = '';
        this.password1 = '';
        this.password2 = '';
        this.role = null;
        this.$refs.addUserForm.resetValidation();
        this.tenantSelected = [];
      },
      addGroup() {
        this.addGroupTitle = this.$t('ADMIN.GROUPS.ADD_GROUP.TITLE');
        this.addGroupText = this.$t('ADMIN.GROUPS.ADD_GROUP.DESC');

        // Set new group ID
        let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        this.groupId = 'G';

        // Generate ID
        for (let j = 0; j < 7; j++) {
            this.groupId += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        this.addGroupDialog = true;
      },
      confirmAddGroup(item) {
        let exists = false;
        let payload = {};

        for(let i = 0; i < this.allGroups.length; i++) {
          if(this.allGroups[i].id == item.groupId) {
            exists = true;
            break;
          }
        }

        if(!exists) {
          this.addGroupDialog = false;

          payload = {
            'id': item.groupId,
            'name': item.groupName,
            'type': 'Workflow',
            'tenant': process.env.VUE_APP_TENANT
          };
          this.$store.dispatch('addGroup', payload).then( () => {
            this.updateLog('Admin', 'Created', 'Group ' + item.groupId + ' created.');

            this.groupId = '';
            this.groupName = '';
            this.$refs.addGroupForm.reset();
            this.$refs.addGroupForm.resetValidation();
            this.refreshGroups();
          });

          // Add group remotely to other tenants
          if(this.tenantSelected.length > 0) {

            let remoteGroupPayload = {
              'groupPayload': payload,
              'tenantSelected': this.tenantSelected,
              'tenantInfo': this.tenantInfo,
              'allHqConns': this.allHqConns            };

            this.$store.dispatch('remoteAddGroup', remoteGroupPayload);
            this.tenantSelected = [];
          }
        }else {
          let msg = 'A group with this ID already exists. Please enter a different ID.';
          this.snackExists(msg);
        }
      },
      cancelAddGroup() {
        this.addGroupDialog = false;
        this.groupId = '';
        this.groupName = '';
        this.$refs.addGroupForm.reset();
        this.$refs.addGroupForm.resetValidation();
      },
      cancelAddDbConnection() {
        this.addDbDialog = false;
        this.dbConnType = null;
        this.dbName = '';
        this.dbIpAddr = '';
        this.dbPort = null;
        this.dbUser = '';
        this.dbPass = '';
        this.$refs.addDbForm.reset();
        this.$refs.addDbForm.resetValidation();
      },
      addDbConnection() {
        this.addDbTitle = this.$t('ADMIN.CONNECTIONS.DATABASES.ADD_CONNECTION.TITLE');
        this.addDbText = this.$t('ADMIN.CONNECTIONS.DATABASES.ADD_CONNECTION.DESC');
        this.addDbDialog = true;
      },
      confirmAddDbConnection(item) {
        this.addDbDialog = false;

        this.connCheckStatus = this.$t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.STATUS.CHECKING');
        this.loadingCheckColour = 'warning';
        this.loadingCheck = true;
        this.connCheckDialog = true;

        let payload = {
          'dbConnType': item.dbConnType,
          'dbName': item.dbName,
          'dbIpAddr': item.dbIpAddr,
          'dbPort': item.dbPort,
          'dbUser': item.dbUser,
          'dbPass': item.dbPass
        };
        this.$store.dispatch('addDbConnection', payload).then( () => {
          this.updateLog('Admin', 'Created', 'Connection to external database ' + item.dbName + ' created.');

          this.dbConnType = null;
          this.dbName = '';
          this.dbIpAddr = '';
          this.dbPort = null;
          this.dbUser = '';
          this.dbPass = '';
          this.$refs.addDbForm.reset();
          this.$refs.addDbForm.resetValidation();
        });
      },
      cancelEditDbConnection() {
        this.editDbDialog = false;
        this.dbConnType = null;
        this.dbName = '';
        this.dbIpAddr = '';
        this.dbPort = null;
        this.dbUser = '';
        this.dbPass = '';
      },
      editDbConnection(item) {
        this.editDbTitle = this.$t('ADMIN.CONNECTIONS.DATABASES.EDIT_CONNECTION.TITLE');
        this.editDbText = this.$t('ADMIN.CONNECTIONS.DATABASES.EDIT_CONNECTION.DESC');
        this.dbConnId = item.ID;
        this.dbConnType = item.CONN_TYPE;
        this.dbName = item.DB_NAME;
        this.dbIpAddr = item.DB_IP_ADDR;
        this.dbPort = item.DB_PORT;
        this.dbUser = item.DB_USER;
        this.dbPass = item.DB_PASS;
        this.editDbDialog = true;
      },
      confirmEditDbConnection(item) {
        this.editDbDialog = false;

        this.connCheckStatus = this.$t('ADMIN.CONNECTIONS.DATABASES.CONNECTION_CHECK.STATUS.CHECKING');
        this.loadingCheckColour = 'warning';
        this.loadingCheck = true;
        this.connCheckDialog = true;

        let payload = {
          'dbConnId': this.dbConnId,
          'dbConnType': item.dbConnType,
          'dbName': item.dbName,
          'dbIpAddr': item.dbIpAddr,
          'dbPort': item.dbPort,
          'dbUser': item.dbUser,
          'dbPass': item.dbPass
        };
        this.$store.dispatch('editDbConnection', payload).then( () => {
          this.updateLog('Admin', 'Updated', 'Connection to external database ' + item.dbName + ' updated.');

          this.dbConnId = '';
          this.dbConnType = null;
          this.dbName = '';
          this.dbIpAddr = '';
          this.dbPort = null;
          this.dbUser = '';
          this.dbPass = '';
        });
      },
      deleteDbConnection(item) {
        this.deleteDbTitle = this.$t('ADMIN.CONNECTIONS.DATABASES.DELETE_CONNECTION.TITLE');
        this.deleteDbText = this.$t('ADMIN.CONNECTIONS.DATABASES.DELETE_CONNECTION.DESC') + ' (' + item.CONN_TYPE + '): ' + item.DB_NAME + ' => ' + this.$t('ADMIN.CONNECTIONS.DATABASES.FIELDS.SERVER_NAME') + ': ' + item.DB_IP_ADDR + ':' + item.DB_PORT;
        this.dbConnId = item.ID;
        this.dbName = item.DB_NAME;
        this.deleteDbDialog = true;
      },
      confirmDeleteDbConnection() {
        this.deleteDbDialog = false;
        this.$store.dispatch('deleteDbConnection', this.dbConnId).then( () => {
          this.updateLog('Admin', 'Deleted', 'Connection to external database ' + this.dbName + ' deleted.');

          this.dbConnId = '';
          this.dbName = '';
        });
      },
      cancelAddHqConnection() {
        this.addHqConnDialog = false;
        this.hqUrl = '';
        this.hqName = '';
        this.$refs.addHqConnForm.reset();
        this.$refs.addHqConnForm.resetValidation();
      },
      addHqConnection() {
        this.addHqConnTitle = this.$t('ADMIN.CONNECTIONS.ENGINES.ADD_ENGINE.TITLE');
        this.addHqConnText = this.$t('ADMIN.CONNECTIONS.ENGINES.ADD_ENGINE.DESC');
        this.addHqConnDialog = true;
      },
      confirmAddHqConnection(item) {
        this.addHqConnDialog = false;

        let payload = {
          'hqUrl': item.hqUrl,
          'hqName': item.hqName
        };
        this.$store.dispatch('addHqConnection', payload).then( () => {
          this.updateLog('Admin', 'Created', 'Connection to Harlequin engine ' + item.hqName + ' created.');

          this.hqUrl = '';
          this.hqName = '';
          this.$refs.addHqConnForm.reset();
          this.$refs.addHqConnForm.resetValidation();
        });
      },
      cancelEditHqConnection() {
        this.editHqConnDialog = false;
        this.hqUrl = '';
        this.hqName = '';
        this.$refs.editHqConnForm.reset();
        this.$refs.editHqConnForm.resetValidation();
      },
      editHqConnection(item) {
        this.editHqConnTitle = this.$t('ADMIN.CONNECTIONS.ENGINES.EDIT_ENGINE.TITLE');
        this.editDbText = this.$t('ADMIN.CONNECTIONS.ENGINES.EDIT_ENGINE.DESC');
        this.hqConnId = item.ID;
        this.hqUrl = item.URL;
        this.hqName = item.ENGINE_NAME;
        this.editHqConnDialog = true;
      },
      confirmEditHqConnection(item) {
        this.editHqConnDialog = false;

        let payload = {
          'hqConnId': this.hqConnId,
          'hqUrl': item.hqUrl,
          'hqName': item.hqName
        };
        this.$store.dispatch('editHqConnection', payload).then( () => {
          this.updateLog('Admin', 'Updated', 'Connection to Harlequin engine ' + item.hqName + ' updated.');

          this.hqConnId = '';
          this.hqUrl = '';
          this.hqName = '';
          this.$refs.editHqConnForm.reset();
          this.$refs.editHqConnForm.resetValidation();
        });
      },
      deleteHqConnection(item) {
        this.deleteHqConnTitle = this.$t('ADMIN.CONNECTIONS.ENGINES.DELETE_ENGINE.TITLE');
        this.deleteHqConnText = this.$t('ADMIN.CONNECTIONS.ENGINES.DELETE_ENGINE.DESC') + ' ' + item.URL;
        this.hqConnId = item.ID;
        this.hqUrl = item.URL;
        this.hqName = item.ENGINE_NAME;
        this.deleteHqConnDialog = true;
      },
      confirmDeleteHqConnection() {
        this.deleteHqConnDialog = false;
        this.$store.dispatch('deleteHqConnection', this.hqConnId).then( () => {
          this.updateLog('Admin', 'Deleted', 'Connection to Harlequin engine ' + this.hqName + ' deleted.');

          this.hqConnId = '';
          this.hqUrl = '';
          this.hqName = '';
        });
      },
      editApi(item) {
        this.editApiTitle = this.$t('ADMIN.API_VAULT.EDIT_API.TITLE') + ' ' + item.FRIENDLY_NAME;
        this.editApiText = this.$t('ADMIN.API_VAULT.EDIT_API.DESC');
        this.apiId = item.ID;
        this.apiName = item.FRIENDLY_NAME;
        this.apiAuthType = item.AUTH_TYPE;
        this.basicUser = item.BASIC_USER;
        this.basicPass = item.BASIC_PASS;
        this.apiKey = item.API_KEY;
        this.apiValue = item.API_VALUE;
        this.apiGrantType = item.GRANT_TYPE;
        this.apiClientId = item.CLIENT_ID;
        this.apiClientSecret = item.CLIENT_SECRET;
        this.apiEndpoint = item.ENDPOINT_URL;
        this.apiHeaders = item.HEADERS;
        this.editApiDialog = true;
      },
      async confirmEditApi(item) {
        this.editApiDialog = false;
        
        let payload = {
          'id': item.apiId,
          'name': item.apiName,
          'authType': item.apiAuthType,
          'basicUser': item.basicUser,
          'basicPass': item.basicPass,
          'apiKey': item.apiKey,
          'apiValue': item.apiValue,
          'grantType': item.apiGrantType,
          'clientId': item.apiClientId,
          'clientSecret': item.apiClientSecret,
          'endpoint': item.apiEndpoint,
          'headers': item.apiHeaders
        };
        this.$store.dispatch('editApi', payload).then( () => {
          this.updateLog('Admin', 'Updated', 'API ' + item.apiName + ' updated.');

          this.apiId = 0;
          this.apiName = '';
          this.apiAuthType = '';
          this.basicUser = '';
          this.basicPass = '';
          this.apiKey = '';
          this.apiValue = '';
          this.apiGrantType = '';
          this.apiClientId = '';
          this.apiClientSecret = '';
          this.apiEndpoint = '';
          this.apiHeaders = '';
          this.refreshApis();
        });
      },
      cancelEditApi() {
        this.editApiDialog = false;
        this.apiId = 0;
        this.apiName = '';
        this.apiAuthType = '';
        this.basicUser = '';
        this.basicPass = '';
        this.apiKey = '';
        this.apiValue = '';
        this.apiGrantType = '';
        this.apiClientId = '';
        this.apiClientSecret = '';
        this.apiEndpoint = '';
        this.apiHeaders = '';
      },
      deleteApi(item) {
        this.deleteApiTitle = this.$t('ADMIN.API_VAULT.DELETE_API.TITLE');
        this.deleteApiText = this.$t('ADMIN.API_VAULT.DELETE_API.DESC') + ' ' + item.FRIENDLY_NAME;
        this.apiId = item.ID;
        this.deleteApiDialog = true;
      },
      confirmDeleteApi(item) {
        this.deleteApiDialog = false;
        this.$store.dispatch('deleteApi', item.apiId).then( () => {
          this.updateLog('Admin', 'Deleted', 'API ' + item.apiName + ' deleted.');

          this.apiId = 0;
          this.apiName = '';
          this.apiAuthType = '';
          this.basicUser = '';
          this.basicPass = '';
          this.apiKey = '';
          this.apiValue = '';
          this.apiGrantType = '';
          this.apiClientId = '';
          this.apiClientSecret = '';
          this.apiEndpoint = '';
          this.apiHeaders = '';
          this.refreshApis();
        });
      },
      addApi() {
        this.addApiTitle = this.$t('ADMIN.API_VAULT.ADD_API.TITLE');
        this.addApiText = this.$t('ADMIN.API_VAULT.ADD_API.DESC');
        this.addApiDialog = true;
      },
      confirmAddApi(item) {
        this.addApiDialog = false;

        let payload = {
          'name': item.apiName,
          'authType': item.apiAuthType,
          'basicUser': item.basicUser,
          'basicPass': item.basicPass,
          'apiKey': item.apiKey,
          'apiValue': item.apiValue,
          'grantType': item.apiGrantType,
          'clientId': item.apiClientId,
          'clientSecret': item.apiClientSecret,
          'endpoint': item.apiEndpoint,
          'headers': item.apiHeaders
        };
        this.$store.dispatch('addApi', payload).then( () => {
          this.updateLog('Admin', 'Created', 'API ' + item.apiName + ' created.');

          this.apiId = 0;
          this.apiName = '';
          this.apiAuthType = '';
          this.basicUser = '';
          this.basicPass = '';
          this.apiKey = '';
          this.apiValue = '';
          this.apiGrantType = '';
          this.apiClientId = '';
          this.apiClientSecret = '';
          this.apiEndpoint = '';
          this.apiHeaders = '';
          this.$refs.addApiForm.reset();
          this.$refs.addApiForm.resetValidation();
          this.refreshApis();
        });
      },
      cancelAddApi() {
        this.addApiDialog = false;
        this.apiId = 0;
        this.apiName = '';
        this.apiAuthType = '';
        this.basicUser = '';
        this.basicPass = '';
        this.apiKey = '';
        this.apiValue = '';
        this.apiGrantType = '';
        this.apiClientId = '';
        this.apiClientSecret = '';
        this.apiEndpoint = '';
        this.apiHeaders = '';
        this.$refs.addApiForm.reset();
        this.$refs.addApiForm.resetValidation();
      },
      snackSave () {
        this.snack = true;
        this.snackColor = 'success';
        this.snackText = 'Data saved successfully.';
      },
      snackExists (msg) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = msg;
      },
      snackErrorMessage () {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = this.userErrorMsg;
      },
      snackEngineError () {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = 'The engine could not be added. Please check the URL and try again.';
      },
      snackTenantError () {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = 'The tenants for this engine could not be added. Please check the URL and try again.';
      },
      snackOpLogError() {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = this.operationLogError;
      },
      snackErrorLogError() {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = this.errorLogError;
      },
      snackErrorLogCleared() {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'success';
        this.snackText = 'Error log cleared successfully.';
      },
      snackRemoteUserOk (msg) {
        this.snack = true;
        this.snackColor = 'success';
        this.snackText = msg;
      },
      snackRemoteUserFail (msg) {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = msg;
      },
      snackRemoteRoleFail () {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = 'Remote user could not be added to the necessary role.';
      },
      snackMiscSuccess (msg) {
        this.snack = true;
        this.snackColor = 'success';
        this.snackText = msg;
      },
      snackMiscError (msg) {
        this.snack = true;
        this.snackTimeout = 10000;
        this.snackColor = 'error';
        this.snackText = msg;
      },
      updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>
<style>
  .engine-name {
    margin-top: 5px;
  }
  .tenant-info {
    margin-top: 0 !important;
  }
</style>